import { Component, OnInit, ViewChildren, QueryList } from '@angular/core';
import { ParentDataService } from '../../../service/parent-data.service';
import { DataAnalyticsService } from "../../../../components/dataAnalytics/dataAnalytics.service";
import { AddStudentRcModel, rciModel } from "../../../../components/dataAnalytics/dataAnalytics.model";
import { LocalStorageService } from "ng2-webstorage";
import { ChartDataSets, ChartOptions } from 'chart.js';
import { Color } from 'ng2-charts';
import { ChartsModule } from 'ng2-charts/ng2-charts';
import { BaseChartDirective } from 'ng2-charts/ng2-charts';
import { Router, ActivatedRoute } from '@angular/router';
import { ChangeDetectorRef } from '@angular/core';


@Component({
  selector: 'historical-data-summary',
  templateUrl: './summary.component.html',
  styleUrls: ['./summary.component.css']
})
export class HistoricalDataSummaryComponent implements OnInit {

  @ViewChildren(BaseChartDirective) charts: QueryList<BaseChartDirective>;
  public children: any;
  //public loading: boolean = true;
  //public showMenu = false;
  public selectedChild: any;
  public selectedChildId: any;
  //approvalClassModel = new ApprovalClassModel();
  googleUser: any;
  studentList = [];
  courseId: any;

  selected_to_year: any = "2023";
  selected_from_year: any = "2019";

  //selectedGrade: any;
  selectedSection: any;
  selectedSubject: string = "All Subjects";
  sectionList: any = [];
  public newSectionArray = [];
  studentData: any = [];
  sumamryTable: any = [];
  public userdetailes = [];
  confirmFlag: boolean = true;
  thresholdText: number;
  selectedGCl: string = "class";
  gclList: any;
  // SectionId: any;
  selectedDate: any;
  searchFlag: boolean = false;
  studentThresholdList: any = [];
  // guru: any = [];
  subjects: any = [];
  SemesterData: any = [];
  summarySectionId: any;
  summarySubjectId: any;
  summarySemesterId: any;
  SubjectsSectionInfoData: any = [];
  subjectName: any;
  semestertName: any;
  gradeName: any;

  public userId: string;
  public CurrentChild: any;
  public selectedGrade: any;
  NumberOfStudents: any = [];
  public mappedData: any;
  students: any = [];
  studentRCData: any = [];
  TestData: any = [];
  nameofsec: any = [];
  sectionId: any = [];
  loading = "none";
  selectedStudent: any;
  nameofstd: any = [];



  selectedTeacher: any;
  teachers: any = [];


  //teachers
  public selected_chart_type: string = "bar_chart";

  public barChartOptions_stacked: ChartOptions = {
    responsive: true,
    legend: {
      display: true,
      labels: { fontSize: 17 }
    },
    scales: {
      xAxes: [{
        stacked: true,
        display: true,
        scaleLabel: {
          display: true,
          labelString: 'Semester',
          fontSize: 17
        },
        ticks: {
          stepSize: 1
        }
      }],
      yAxes: [{
        display: true,
        stacked: true,
        scaleLabel: {
          display: true,
          labelString: 'Proportion Percentage',
          fontSize: 17
        },
        ticks: {
          beginAtZero: true,
          //steps: 10,
          //stepValue: 1,
          reverse: false,
          callback: function (value) {
            return (value).toFixed(0) + '%'; // convert it to percentage
          },
          //min: 1,
          //max: 60
        }
      }]
    }
  };

  public barChartOptions_bar: ChartOptions = {
    responsive: true,
    legend: {
      display: true,
      labels: { fontSize: 17 }
    },
    scales: {
      xAxes: [{
        display: true,
        scaleLabel: {
          display: true,
          labelString: 'Semester',
          fontSize: 17
        }
      }],
      yAxes: [{
        display: true,
        scaleLabel: {
          display: true,
          labelString: 'Proportion Percentage',
          fontSize: 17
        },
        ticks: {
          beginAtZero: true,
          //steps: 10,
          //stepValue: 1,
          reverse: false,
          callback: function (value) {
            return (value).toFixed(0) + '%'; // convert it to percentage
          },
          //min: 1,
          //max: 60
        }
      }]
    }
  };
  public barChartLabels: any = ['Sem2 21 Gr5', 'Sem2 22 Gr5'];
  public barChartType: any = 'bar';
  public barChartLegend = true;
  public barChartPlugins = [];

  public barChartData: ChartDataSets[] = [
    { data: [22, 15], label: 'A', order: 4 },
    { data: [25, 32], label: 'B', order: 3 },
    { data: [46, 41], label: 'C', order: 2 },
    { data: [5, 13], label: 'Fail', order: 1 },
    //{ data: [25, 25, 25, 24, 24, 25], label: 'Average Score',type: 'line',borderColor: '#021ffa', fill: false, tension: 0, order: 1 },
  ];

  public chartColors: any[] = [
    {
      backgroundColor: ["#E8E35D", "#E8E35D", "#E8E35D", "#E8E35D", "#E8E35D", "#E8E35D"]
    },
    {
      backgroundColor: ["#5DE8A2", "#5DE8A2", "#5DE8A2", "#5DE8A2", "#5DE8A2", "#5DE8A2"]
    },

    {
      backgroundColor: ["#5DDCE8", "#5DDCE8", "#5DDCE8", "#5DDCE8", "#5DDCE8", "#5DDCE8"]
    },
    {
      backgroundColor: ["#D9320E", "#D9320E", "#D9320E", "#D9320E", "#D9320E", "#D9320E"]
    },
    {
      //strokeColor: ["#021ffa", "#021ffa", "#021ffa", "#021ffa", "#021ffa", "#021ffa"],
      //fillColor: ["#021ffa", "#021ffa", "#021ffa", "#021ffa", "#021ffa", "#021ffa"],
      //borderColor: ["#021ffa", "#021ffa", "#021ffa", "#021ffa", "#021ffa", "#021ffa"],
      //pointBackgroundColor: ["#021ffa", "#021ffa", "#021ffa", "#021ffa", "#021ffa", "#021ffa"],
      //pointHoverBackgroundColor: ["#021ffa", "#021ffa", "#021ffa", "#021ffa", "#021ffa", "#021ffa"],
      //borderColor: ["#021ffa", "#021ffa", "#021ffa", "#021ffa", "#021ffa", "#021ffa"],
      //pointBorderColor: ["#021ffa", "#021ffa", "#021ffa", "#021ffa", "#021ffa", "#021ffa"],
      //pointHoverBorderColor: ["#021ffa", "#021ffa", "#021ffa", "#021ffa", "#021ffa", "#021ffa"],
    }
  ];

  public lineChartData2: ChartDataSets[] = [
    { data: [62, 64, 59, 64, 62, 65], label: 'Grade Average (All Teachers)', fill: false, tension: 0.1, borderColor: "#bae755", backgroundColor: '#cc920c', },
    { data: [57, 61, 52, 60, 55, 60], label: 'Teacher Average (Individual)', fill: false, tension: 0.1, borderColor: 'rgba(77,83,96,1)', }
  ];
  public lineChartLabels2: any = ['Sem1 20 Gr7', 'Sem2 20 Gr7', 'Sem3 20 Gr7', 'Sem1 21 Gr8', 'Sem2 21 Gr8', 'Sem3 21 Gr8'];
  public lineChartType2 = 'line';
  public lineChartLegend2 = true;
  public lineChartPlugins2 = [];
  public lineChartOptions2: (ChartOptions & { annotation: any }) = {
    responsive: true,
    legend: {
      display: true,
      labels: { fontSize: 17 }
    },
    scales: {
      xAxes: [{
        display: true,
        scaleLabel: {
          display: true,
          labelString: 'Semester',
          fontSize: 17
        }
      }],
      yAxes: [{
        display: true,
        scaleLabel: {
          display: true,
          labelString: 'Average score of students (for a particular teacher)',
          fontSize: 17
        },
        ticks: {
          beginAtZero: false,
          steps: 5,
          stepValue: 1,
          reverse: false,
          min: 30,
          max: 65,
          callback: function (value) {
            return (value).toFixed(0) + '%'; // convert it to percentage
          },
        }
      }]
    },
    title: {
      display: false,
      text: 'Chart.js Line Chart - Legend'
    }

  };


  //students

  public lineChartData: ChartDataSets[] = [
    { data: [7, 4, 4, 6, 7, 6], label: 'Student\'s Position (for semester)', fill: false, tension: 0.1, borderColor: "#bae755", backgroundColor: '#cc920c', }/*,
    { data: [5.5, 5.5, 5.5, 5.5, 5.5, 5.5], label: 'Student\'s Average Position (for total period)', fill: false, tension: 0.1,borderColor: 'rgba(77,83,96,1)'}*/];

  public lineChartLabels: any = ['Sem1 20 Gr7', 'Sem2 20 Gr7', 'Sem3 20 Gr7', 'Sem1 21 Gr8', 'Sem2 21 Gr8', 'Sem3 21 Gr8'];
  public lineChartType = 'line';
  public lineChartLegend = true;
  public lineChartPlugins = [];
  public lineChartOptions: (ChartOptions & { annotation: any }) = {
    responsive: true,
    legend: {
      display: true,
      position: 'bottom',
      labels: { fontSize: 17 }
    },
    /*tooltips: {
      enabled: true,
      callbacks: {
        label: function(tooltipItem, data) {
          var label = data.labels[tooltipItem.index];
          var datasetLabel = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
          return label  + ' '+ datasetLabel + '%';

        }
      }
    },*/
    scales: {
      xAxes: [{
        display: true,
        scaleLabel: {
          display: false,
          labelString: 'Month'
        }
      }],
      yAxes: [{
        display: true,
        scaleLabel: {
          display: true,
          labelString: 'Position',
          fontSize: 17
        },
        ticks: {
          beginAtZero: false,
          steps: 10,
          stepValue: 1,
          reverse: true,
          min: 1,
          precision: 0
          //max: 8
        }
      }]
    },
    title: {
      display: false,
      text: 'Chart.js Line Chart - Legend'
    }

  };


  public barChartOptions2: ChartOptions = {
    responsive: true,
    scales: {
      xAxes: [{
        display: true,
        scaleLabel: {
          display: false,
          labelString: 'Month'
        }
      }],
      yAxes: [{
        display: true,
        ticks: {
          beginAtZero: false,
          steps: 10,
          stepValue: 1,
          min: 0,
          max: 100,
          callback: function (value) {
            return (value).toFixed(0) + '%'; // convert it to percentage
          },
        }
      }]
    },
    title: {
      display: false,
      text: 'Chart.js Line Chart - Legend'
    }
  };
  public barChartLabels2: any = ['Sem1 20 Gr7', 'Sem2 20 Gr7', 'Sem3 20 Gr7', 'Sem1 21 Gr8', 'Sem2 21 Gr8', 'Sem3 21 Gr8'];
  public barChartType2: any = 'bar';
  public barChartLegend2 = true;
  public barChartPlugins2 = [];

  public barChartData2: ChartDataSets[] = [
    { data: [86, 88, 85, 91, 80, 78], label: 'Student\'s Score (for semester)', backgroundColor: '	#FFA500', order: 2 }/*,
    { data: [84, 84, 84, 84, 84, 84], label: 'Class Average Score (for total period)', type: 'line', backgroundColor: '	#FFA500', fill: false, tension: 0, order: 1 },*/
  ];




  public barChartOptionsS: ChartOptions = {
    responsive: true,
    scales: {
      xAxes: [{
        display: true,
        scaleLabel: {
          display: false,
          labelString: 'Month'
        }
      }],
      yAxes: [{
        display: true,
        ticks: {
          beginAtZero: false,
          steps: 5,
          stepValue: 1,
          min: 0,
          max: 100,
          callback: function (value) {
            return (value).toFixed(0) + '%'; // convert it to percentage
          },
        }
      }]
    },
    title: {
      display: false,
      text: 'Chart.js Line Chart - Legend'
    }
  };

  //-----Hiedu SubSubject Score Chart------------

  public barChartOptionsSHedu: ChartOptions = {
    responsive: true,
    scales: {
      xAxes: [{
        display: true,
        scaleLabel: {
          display: false,
          labelString: 'Month'
        }
      }],
      yAxes: [{
        display: true,
        ticks: {
          beginAtZero: false,
          steps: 5,
          stepValue: 1,
          min: 0,
          max: 100,
          callback: function (value) {
            return (value).toFixed(0) + '%'; // convert it to percentage
          },
        }
      }]
    },
    title: {
      display: false,
      text: 'Chart.js Line Chart - Legend'
    }
  };


  //----Hiedu------------------------------
  public barChartLabelsSHedu: any = ['Sub Module'];
  public barChartDataSHedu: ChartDataSets[] = [{ data: [86], label: 'Sub Module Score', backgroundColor: '#FFA500', order: 2 }];
  public barChartTypeSHedu: any = 'bar';
  public barChartLegendSHedu = true;
  public barChartPluginsSHedu = [];


  public barChartTypeS: any = 'bar';
  public barChartLegendS = true;
  public barChartPluginsS = [];

  public barChartLabelsS: any = ['Theory'];
  public barChartDataS: ChartDataSets[] = [{ data: [86], label: 'Sub Subject Score', backgroundColor: '#FFA500', order: 2 }];






  public barChartOptions3: ChartOptions = {
    responsive: true,
    legend: {
      display: true,
      position: 'top', labels: { fontSize: 17 }
    },
    scales: {
      xAxes: [{
        display: true,
        scaleLabel: {
          display: true,
          labelString: 'Exam',
          fontSize: 17
        }
      }],
      yAxes: [{
        display: true,
        scaleLabel: {
          display: true,
          labelString: 'Student\'s Subject Score',
          fontSize: 17
        },
        ticks: {
          beginAtZero: false,
          steps: 10,
          stepValue: 1,
          min: 0,
          max: 100,
          callback: function (value) {
            return (value).toFixed(0) + '%'; // convert it to percentage
          },
        }
      }],
    },
    title: {
      display: false,
      text: 'Chart.js Line Chart - Legend'
    }
  };
  public barChartLabels3: any = ['Sem1 20 Gr7', 'Sem2 20 Gr7', 'Sem3 20 Gr7', 'Sem1 21 Gr8', 'Sem2 21 Gr8', 'Sem3 21 Gr8'];
  public barChartType3: any = 'bar';
  public barChartLegend3 = true;
  public barChartPlugins3 = [];

  public barChartData3: ChartDataSets[] = [
    { data: [30, 40, 30, 20, 25, 30], label: 'Top 25-50', backgroundColor: 'red', order: 4 },
    { data: [50, 50, 60, 70, 55, 55], label: 'Top 10-25', backgroundColor: '#FFA500', order: 3 },
    { data: [70, 65, 75, 80, 80, 81], label: 'Top 10', backgroundColor: '#FFA500', order: 2 },
    { data: [55, 58, 69, 59, 70, 77], label: 'Student', type: 'line', fill: false, tension: 0, order: 1, borderColor: "#2072d6", backgroundColor: "#2072d6", pointBackgroundColor: "#2072d6", pointBorderColor: "#2072d6" }
  ];

  public chartColors2: any[] = [
    {
      backgroundColor: ["#bf3321", "#bf3321", "#bf3321", "#bf3321", "#bf3321", "#bf3321"]
    },
    {
      backgroundColor: ["#c7675a", "#c7675a", "#c7675a", "#c7675a", "#c7675a", "#c7675a"]
    },
    {
      backgroundColor: ["#eb9e94", "#eb9e94", "#eb9e94", "#eb9e94", "#eb9e94", "#eb9e94"]
    }
  ];



  public barChartOptions4: ChartOptions = {
    responsive: true,
    legend: {
      display: true,
      position: 'bottom', labels: { fontSize: 17 }
    },
    scales: {
      xAxes: [{
        display: true,
        scaleLabel: {
          display: false,
          labelString: 'Month'
        }
      }],
      yAxes: [{
        display: true,
        scaleLabel: {
          display: true,
          labelString: '# of students',
          fontSize: 17
        },
        ticks: {
          beginAtZero: false,
          steps: 10,
          stepValue: 1,
          min: 0
        }
      }],
    },
    title: {
      display: true,
      text: 'Number of students',
      fontSize: 17
    }
  };
  public barChartLabels4: any = ['2019', '2020', '2021', '2022'];
  public barChartType4: any = 'bar';
  public barChartLegend4 = true;
  public barChartPlugins4 = [];

  public barChartData4: ChartDataSets[] = [
    { data: [0, 0, 0, 0], label: 'Maths', backgroundColor: 'red', order: 2 },
  ];



  public barChartOptions5: ChartOptions = {
    responsive: true,
    legend: {
      display: true,
      position: 'bottom', labels: { fontSize: 17 }
    },
    scales: {
      xAxes: [{
        display: true
      }],
      yAxes: [{
        display: true,
        scaleLabel: {
          display: true,
          labelString: '# of students',
          fontSize: 17
        },
        ticks: {
          beginAtZero: false,
          steps: 10,
          stepValue: 1,
          min: 0
        }
      }],
    },
    title: {
      display: true,
      text: 'Number of students in A/L streams',
      fontSize: 17
    }
  };
  public barChartLabels5: any = ['2019', '2020', '2021', '2022'];
  public barChartType5: any = 'bar';
  public barChartLegend5 = true;
  public barChartPlugins5 = [];

  public barChartData5: ChartDataSets[] = [
    { data: [0, 0, 0, 0], label: 'Physics', backgroundColor: 'red', order: 2 },
    { data: [0, 0, 0, 0], label: 'Chemistry', backgroundColor: '#FFA500', order: 2 },
    { data: [0, 0, 0, 0], label: 'Biology', backgroundColor: '#FFA500', order: 2 },
  ];






  public barChartOptions6: ChartOptions = {
    responsive: true,
    legend: {
      display: true,
      position: 'top', labels: { fontSize: 17 }
    },
    scales: {
      xAxes: [{
        display: true,
        scaleLabel: {
          display: true,
          labelString: 'Year',
          fontSize: 17
        }
      }],
      yAxes: [{
        display: true,
        scaleLabel: {
          display: true,
          labelString: '# of players',
          fontSize: 17
        },
        ticks: {
          beginAtZero: false,
          steps: 10,
          stepValue: 1,
          min: 0
        }
      }],
    },
    title: {
      display: false,
      text: 'Cricket Composition'
    }
  };
  public barChartLabels6: any = ['2019', '2020', '2021', '2022'];
  public barChartType6: any = 'bar';
  public barChartLegend6 = true;
  public barChartPlugins6 = [];

  public barChartData6: ChartDataSets[] = [
    { data: [30, 40, 30, 35], label: 'Under 11', backgroundColor: 'red', order: 2 },
    { data: [29, 35, 28, 20], label: 'Under 14', backgroundColor: '#FFA500', order: 2 },
    { data: [26, 25, 23, 20], label: 'Under 16', backgroundColor: '#FFA500', order: 2 },
  ];






  public barChartOptions7: ChartOptions = {
    responsive: true,
    legend: {
      display: true,
      position: 'top', labels: { fontSize: 17 }
    },
    scales: {
      xAxes: [{
        display: true,
        scaleLabel: {
          display: true,
          labelString: 'Year',
          fontSize: 17
        }
      }],
      yAxes: [{
        display: true,
        scaleLabel: {
          display: true,
          labelString: '# of players',
          fontSize: 17
        },
        ticks: {
          beginAtZero: false,
          steps: 10,
          stepValue: 1,
          min: 0
        }
      }],
    },
    title: {
      display: false,
      text: 'Tennis Composition'
    }
  };
  public barChartLabels7: any = ['2019', '2020', '2021', '2022'];
  public barChartType7: any = 'bar';
  public barChartLegend7 = true;
  public barChartPlugins7 = [];

  public barChartData7: ChartDataSets[] = [
    { data: [30, 25, 22, 21], label: 'Under 11', backgroundColor: 'red', order: 2 },
    { data: [25, 17, 8, 7], label: 'Under 14', backgroundColor: '#FFA500', order: 2 },
    { data: [11, 15, 6, 6], label: 'Under 16', backgroundColor: '#FFA500', order: 2 },
  ];



  //Acedemic chart - Position vs final Exam
  public lineChartData3: ChartDataSets[] = [
    { data: [0, 0, 0, 0], label: 'Student 10', fill: false, tension: 0.1, borderColor: '#00a8d6' },
  ];

  public lineChartLabels3: any = ['Grade 7', 'Grade 8', 'Grade 9', 'Grade 10'];
  public lineChartType3 = 'line';
  public lineChartLegend3 = true;
  public lineChartPlugins3 = [];
  public lineChartOptions3: (ChartOptions & { annotation: any }) = {
    responsive: true,
    legend: { display: false, position: 'bottom', labels: { fontSize: 17 } },
    scales: {
      xAxes: [{ display: true, offset: 20, gridLines: false, scaleLabel: { display: true, labelString: 'Exam', fontSize: 17 } }],
      yAxes: [{ display: true, scaleLabel: { display: true, labelString: 'Class Position', fontSize: 17 }, ticks: { beginAtZero: false, steps: 10, stepValue: 1, reverse: true, min: 1, precision: 0/*max: 8*/ } }]
    },
    title: { display: false, text: 'Chart.js Line Chart - Legend' }
  };
  public chartColors3: any[] = [{}, {}, {}, {}];


  //Acedemic chart - Subject Position Correlation
  public scatterChartData2: ChartDataSets[] = [
    {
      data: [
        /*{x: 5, y: 78},
        {x: 2, y: 57},
        {x: 15, y: 19},
        {x: 6, y: 68},
        {x: 11, y: 57},
        {x: 16, y: 52},
        {x: 17, y: 49},
        {x: 21, y: 17},
        {x: 12, y: 88},
        {x: 10, y: 47},*/
      ], label: 'Maths vs Class Position', backgroundColor: "#00a8d6"
    }
  ];

  public scatterChartLabels2: any = [];
  public scatterChartType2 = 'scatter';
  public scatterChartLegend2 = true;
  public scatterChartPlugins2 = [];
  public scatterChartOptions2: (ChartOptions & { annotation: any }) = {
    responsive: true,
    elements: { point: { radius: 4, hoverRadius: 5, hitRadius: 5 } },
    legend: { display: true, position: 'top', labels: { fontSize: 17 } },
    scales: {
      xAxes: [{ display: true, offset: 10, gridLines: false, scaleLabel: { display: true, labelString: 'Class Position', fontSize: 17 }, ticks: { beginAtZero: false, steps: 10, stepValue: 1, reverse: false, min: 1, precision: 0 } }],
      yAxes: [{ display: true, scaleLabel: { display: true, labelString: '', fontSize: 17 }, ticks: { beginAtZero: true, steps: 10, stepValue: 1, reverse: false, min: 0, max: 100, callback: function (value) { return (value).toFixed(0) + '%'; } } }]
    },
    title: { display: false, text: 'Maths vs Class Position' }
  };



  //Acedemic chart - Practical vs. Acedemic
  public barChartOptions8: ChartOptions = {
    responsive: true,
    legend: { display: true, position: 'top', labels: { fontSize: 17 } },
    scales: {
      xAxes: [{ display: true, scaleLabel: { display: true, labelString: 'Class', fontSize: 17 } }],
      yAxes: [{ display: true, scaleLabel: { display: true, labelString: 'Marks Percentage', fontSize: 17 }, ticks: { beginAtZero: false, steps: 10, stepValue: 1, min: 0, callback: function (value) { return (value).toFixed(0) + '%'; } } }],
    },
    title: { display: false, text: 'Tennis Composition' }
  };
  public barChartLabels8: any = ['Grade 5 Term 2', 'Grade 5 Term 3'];
  public barChartType8: any = 'bar';
  public barChartLegend8 = true;
  public barChartPlugins8 = [];
  public barChartData8: ChartDataSets[] = [
    { data: [0, 0], label: 'Academic', backgroundColor: 'red', order: 2 },
    { data: [0, 0], label: 'Practicals', backgroundColor: '#FFA500', order: 2 },
  ];
  public chartColors4: any[] = [
    {
      backgroundColor: ["#4bacc6", "#4bacc6"]
    },
    {
      backgroundColor: ["#f79645", "#f79645"]
    }
  ];



  //Acedemic chart - Qualitative Performance
  public barChartOptions9: ChartOptions = {
    responsive: true,
    legend: { display: true, position: 'bottom', labels: { fontSize: 17 } },
    scales: {
      xAxes: [{ display: true, stacked: true, scaleLabel: { display: true, labelString: 'Semester', fontSize: 17 } }],
      yAxes: [{ display: true, stacked: true, scaleLabel: { display: true, labelString: '# of Digital Report Card comments', fontSize: 17 }, ticks: { beginAtZero: false, steps: 10, stepValue: 1, min: 0, callback: function (value) { return (value).toFixed(0) + ''; } } }],
    },
    title: { display: false, text: 'Tennis Composition' }
  };
  public barChartLabels9: any = ['Grade 7 Sem 1', 'Grade 7 Sem 2', 'Grade 7 Sem 3', 'Grade 8 Sem 1', 'Grade 8 Sem 2', 'Grade 8 Sem 3'];
  public barChartType9: any = 'bar';
  public barChartLegend9 = true;
  public barChartPlugins9 = [];
  public barChartData9: ChartDataSets[] = [
    { data: [5, 4, 5, 6, 7, 8], label: 'Very good', backgroundColor: 'red', order: 2 },
    { data: [2, 0, 2, 2, 0, 2], label: 'Good', backgroundColor: '#FFA500', order: 2 },
    { data: [1, 3, 1, 1, 1, 0], label: 'Could do better', backgroundColor: '#FFA500', order: 2 },
    { data: [1, 1, 1, 1, 1, 0], label: 'Needs Improvement', backgroundColor: '#FFA500', order: 2 },
    { data: [1, 2, 1, 0, 1, 0], label: 'Other', backgroundColor: '#FFA500', order: 2 },
    { data: [0, 0, 0, 0, 0, 0], label: 'No comment', backgroundColor: '#FFA500', order: 2 },
  ];
  public chartColors5: any[] = [
    {
      backgroundColor: ["#4bacc6", "#4bacc6", "#4bacc6", "#4bacc6", "#4bacc6", "#4bacc6"]
    },
    {
      backgroundColor: ["#9fc4e8", "#9fc4e8", "#9fc4e8", "#9fc4e8", "#9fc4e8", "#9fc4e8"]
    },
    {
      backgroundColor: ["#f79645", "#f79645", "#f79645", "#f79645", "#f79645", "#f79645"]
    },
    {
      backgroundColor: ["#f79645", "#f79645", "#f79645", "#f79645", "#f79645", "#f79645"]
    },
    {
      backgroundColor: ["#f9b3b5", "#f9b3b5", "#f9b3b5", "#f9b3b5", "#f9b3b5", "#f9b3b5"]
    },
    {
      backgroundColor: ["#cecece", "#cecece", "#cecece", "#cecece", "#cecece", "#cecece"]
    }
  ];


  //Acedemic chart - Message propensity
  public barChartOptions10: ChartOptions = {
    responsive: true,
    legend: { display: true, position: 'top', labels: { fontSize: 17 } },
    scales: {
      xAxes: [{ display: true, stacked: true, scaleLabel: { display: true, labelString: 'Month', fontSize: 17 } }],
      yAxes: [{ display: true, stacked: true, scaleLabel: { display: true, labelString: '# of messages', fontSize: 17 }, ticks: { beginAtZero: false, steps: 10, stepValue: 1, min: 0, callback: function (value) { return (value).toFixed(0) + ''; } } }],
    },
    title: { display: false, text: 'Tennis Composition' }
  };
  public barChartLabels10: any = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun'];
  public barChartType10: any = 'bar';
  public barChartLegend10 = true;
  public barChartPlugins10 = [];
  public barChartData10: ChartDataSets[] = [
    { data: [0, 0, 0, 0, 0, 0], label: 'Grade 1', backgroundColor: 'red', order: 2 },
    { data: [0, 0, 0, 0, 0, 0], label: 'Grade 2', backgroundColor: '#FFA500', order: 2 },
    { data: [0, 0, 0, 0, 0, 0], label: 'Grade 3', backgroundColor: '#FFA500', order: 2 },
    { data: [0, 0, 0, 0, 0, 0], label: 'Grade 4', backgroundColor: '#FFA500', order: 2 },
  ];
  public chartColors6: any[] = [
    {
      backgroundColor: ["#0a5394", "#0a5394", "#0a5394", "#0a5394", "#0a5394", "#0a5394"]
    },
    {
      backgroundColor: ["#3c85c6", "#3c85c6", "#3c85c6", "#3c85c6", "#3c85c6", "#3c85c6"]
    },
    {
      backgroundColor: ["#70a8dc", "#70a8dc", "#70a8dc", "#70a8dc", "#70a8dc", "#70a8dc"]
    },
    {
      backgroundColor: ["#a4c2f4", "#a4c2f4", "#a4c2f4", "#a4c2f4", "#a4c2f4", "#a4c2f4"]
    }
  ];




  //scatter chart
  public scatterChartOptions: ChartOptions = {
    responsive: true,
    legend: { display: true, position: 'top', labels: { fontSize: 17 } },
    scales: {
      x: {
        display: true,
        type: 'linear',
        position: 'bottom',
      },
      xAxes: [{
        display: true,
        scaleLabel: {
          display: true,
          labelString: '',
          fontSize: 17
        },
        ticks: {
          beginAtZero: true,
          min: 0,
          max: 100,
          callback: function (value) {
            return (value).toFixed(0) + '%'; // convert it to percentage
          },
        }
      }],
      yAxes: [{
        display: true,
        scaleLabel: {
          display: true,
          labelString: '',
          fontSize: 17
        },
        ticks: {
          beginAtZero: true,
          min: 0,
          max: 100,
          callback: function (value) {
            return (value).toFixed(0) + '%'; // convert it to percentage
          },
        }
      }]
    }
  };
  public scatterChartLabels: any = ['Sem1 20 Gr7', 'Sem2 20 Gr7', 'Sem3 20 Gr7', 'Sem1 21 Gr8', 'Sem2 21 Gr8', 'Sem3 21 Gr8'];
  public scatterChartType: any = 'scatter';
  public scatterChartLegend = true;
  public scatterChartPlugins = [];

  /*public scatterChartData: ChartDataSets[] = [
    { data: [{"x":62,"y":67},{"x":41,"y":68},{"x":88,"y":99},{"x":86,"y":88},{"x":41,"y":80},{"x":57,"y":89},{"x":29,"y":88},{"x":41,"y":63},{"x":67,"y":84},{"x":42,"y":83},{"x":78,"y":89},{"x":77,"y":85},{"x":50,"y":86},{"x":84,"y":90},{"x":38,"y":88},{"x":29,"y":60},{"x":78,"y":100},{"x":43,"y":65},{"x":21,"y":61},{"x":60,"y":84},{"x":67,"y":90},{"x":83,"y":100},{"x":77,"y":80},{"x":75,"y":75},{"x":47,"y":63},{"x":42,"y":85},{"x":89,"y":96},{"x":86,"y":71},{"x":97,"y":96},{"x":12,"y":72},{"x":76,"y":87},{"x":66,"y":66},{"x":59,"y":93}], label: 'Maths vs. Science', backgroundColor: 'blue' },
    //{ data: [{x: 11,y: 0}, {x: 1,y: 10}, {x: 10,y: 5}, {x: 6,y: 6}], label: 'Science', backgroundColor: 'blue' },
  ];*/


  // Define X and Y arrays
  public X1 = [59, 19, 17, 34, 37, 73, 61, 60, 12, 0, 86, 41, 77, 49, 42, 29, 38, 30, 43, 60, 0, 6, 64, 55, 67, 51, 9, 65, 48, 61, 0, 0, 66, 77, 52, 0, 86, 89, 20, 0, 0, 43, 12, 64, 28, 49, 72, 32, 17, 41, 75, 100, 54, 29, 10, 10, 7, 95, 74, 55, 14, 97, 45, 63, 56, 97, 19, 47, 13, 78, 64, 9, 71, 22, 63, 18, 43, 17, 19, 30, 56, 23, 46, 42, 51, 49, 52, 15, 65, 66, 60, 22, 6, 45, 44, 32, 66];
  public Y1 = [77, 53, 48, 48, 75, 85, 84, 62, 44, 0, 91, 32, 86, 77, 82, 0, 55, 23, 51, 84, 0, 37, 68, 0, 60, 86, 25, 80, 77, 44, 0, 65, 97, 0, 48, 0, 76, 85, 72, 0, 0, 74, 25, 79, 0, 67, 84, 47, 41, 64, 91, 99, 56, 58, 30, 21, 22, 95, 77, 72, 23, 93, 0, 97, 69, 73, 50, 66, 0, 92, 72, 20, 78, 60, 79, 49, 52, 24, 40, 70, 78, 70, 76, 74, 74, 79, 30, 29, 91, 52, 56, 0, 59, 81, 86, 64, 68];

  public X2 = [54, 25, 8, 30, 36, 60, 67, 63, 9, 12, 70, 34, 83, 61, 52, 30, 40, 17, 34, 44, 0, 2, 44, 36, 58, 59, 7, 76, 64, 53, 19, 0, 65, 55, 73, 94, 58, 42, 0, 80, 24, 81, 40, 61, 86, 51, 59, 67, 94, 98, 55, 66, 25, 21, 19, 96, 65, 75, 27, 91, 75, 93, 69, 78, 44, 71, 22, 92, 77, 30, 80, 55, 77, 40, 64, 21, 40, 67, 91, 68, 62, 61, 76, 77, 27, 19, 87, 49, 61, 51, 55, 75, 63, 66, 84];
  public Y2 = [77, 36, 46, 60, 83, 91, 87, 64, 42, 38, 95, 42, 85, 77, 69, 50, 50, 39, 60, 72, 0, 37, 82, 53, 70, 82, 26, 80, 83, 56, 32, 0, 0, 60, 38, 44, 36, 16, 35, 0, 44, 12, 13, 16, 12, 15, 13, 12, 10, 44, 48, 40, 28, 10, 26, 12, 50, 34, 48, 45, 48, 26, 37, 17, 40, 26, 29, 4, 32, 41, 17, 22, 0, 34, 16, 7, 8, 6, 14, 50, 15, 46, 31, 34, 30, 0, 8, 46, 18, 8, 16, 8, 26, 16, 40, 36];

  // Transform X and Y arrays into an array of objects with x and y properties
  public data1 = this.X1.map((x, index) => ({ x, y: this.Y1[index] }));
  public data2 = this.X2.map((x, index) => ({ x, y: this.Y2[index] }));

  // Define scatterChartData array with the transformed data
  public scatterChartData: ChartDataSets[] = [
    { data: this.data1, label: 'Maths vs. Science', backgroundColor: 'blue' },
  ];


  public radarChartOptions: ChartOptions = {
    legend: { display: true, position: 'top', labels: { fontSize: 17 } },
    scale: {
      ticks: {
        beginAtZero: true,
        max: 100,
        min: 0,
        callback: function (value) {
          return (value).toFixed(0) + '%'; // convert it to percentage
        },
      }
    },
  };

  //-------------------------------------------------------------------------------------
  public radarChartLabels: any = ['Sinhala', 'Maths', 'Science', 'IT', 'Geography', 'History', 'Art'];
  public radarChartType: any = 'radar';
  public radarChartLegend = true;
  public radarChartPlugins = [];

  public radarChartData: ChartDataSets[] = [
    {
      label: 'Student\'s Scores',
      data: [65, 59, 90, 81, 56],
      fill: true,
      backgroundColor: 'rgba(255, 99, 132, 0.2)',
      borderColor: 'rgb(255, 99, 132)',
      pointBackgroundColor: 'rgb(255, 99, 132)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgb(255, 99, 132)'
    },
    {
      label: 'Average Scores',
      data: [60, 50, 70, 60, 75],
      fill: true,
      backgroundColor: 'rgba(255, 99, 255, 0.2)',
      borderColor: 'rgb(255, 99, 255)',
      pointBackgroundColor: 'rgb(255, 99, 255)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgb(255, 99, 255)'
    }
  ];
//-----------------------Hiedu --------------------------------------------------------------

   //-----------------------Hiedu --------------------------------------------------------------
  //  public radarChartLabelsH: any = ['International Relations for Business', 'Study Skills for Business', 'Communication Skills for Business', 'Introduction to Economics'];
  //  public radarChartTypeH: any = 'radar';
  //  public radarChartLegendH = true;
  //  public radarChartPluginsH = [];

  //  public radarChartDataH: ChartDataSets[] = [
  //    {
  //      label: 'Student\'s Scores',
  //      data: [65, 59, 90, 81],
  //      fill: true,
  //      backgroundColor: 'rgba(255, 99, 132, 0.2)',
  //      borderColor: 'rgb(255, 99, 132)',
  //      pointBackgroundColor: 'rgb(255, 99, 132)',
  //      pointBorderColor: '#fff',
  //      pointHoverBackgroundColor: '#fff',
  //      pointHoverBorderColor: 'rgb(255, 99, 132)'
  //    },
  //    {
  //      label: 'Average Scores',
  //      data: [60, 50, 70, 60],
  //      fill: true,
  //      backgroundColor: 'rgba(255, 99, 255, 0.2)',
  //      borderColor: 'rgb(255, 99, 255)',
  //      pointBackgroundColor: 'rgb(255, 99, 255)',
  //      pointBorderColor: '#fff',
  //      pointHoverBackgroundColor: '#fff',
  //      pointHoverBorderColor: 'rgb(255, 99, 255)'
  //    }
  //  ];


  //-----------------------Hiedu  Radar Chart --------------------------------------------------------------
  public radarChartOptionsH: ChartOptions = {
    legend: { display: true, position: 'top', labels: { fontSize: 17 } },
    scale: {
      ticks: {
        beginAtZero: true,
        max: 100,
        min: 0,
        callback: function (value) {
          return (value).toFixed(0) + '%'; // convert it to percentage
        },
      }
    },
  };


public radarChartLabelsH: any = ['International Relations for Business', 'Study Skills for Business', 'Communication Skills for Business', 'Introduction to Economics']; // for subject names
public radarChartTypeH = 'radar';
public radarChartLegendH = true;


public radarChartDataH: ChartDataSets[] = [
  {
          label: 'Student Marks',
          data: [50, 85, 80, 85],
          fill: true,
          backgroundColor: 'rgba(255, 99, 132, 0.2)',
          borderColor: 'rgb(255, 99, 132)',
          pointBackgroundColor: 'rgb(255, 99, 132)',
          pointBorderColor: '#fff',
          pointHoverBackgroundColor: '#fff',
          pointHoverBorderColor: 'rgb(255, 99, 132)'

},
  {
          label: 'Average Marks',
          data: [80, 75, 55, 75],
          fill: true,
          backgroundColor: 'rgba(255, 99, 255, 0.2)',
          borderColor: 'rgb(255, 99, 255)',
          pointBackgroundColor: 'rgb(255, 99, 255)',
          pointBorderColor: '#fff',
          pointHoverBackgroundColor: '#fff',
          pointHoverBorderColor: 'rgb(255, 99, 255)'

  },
];



  //Acedemic chart - Student churn
  public barChartOptions11: ChartOptions = {
    responsive: true,
    legend: { display: true, position: 'top', labels: { fontSize: 17 } },
    scales: {
      xAxes: [{ display: true, stacked: true, scaleLabel: { display: true, labelString: 'Semester', fontSize: 17 } }],
      yAxes: [{ display: true, stacked: true, scaleLabel: { display: true, labelString: '# of students', fontSize: 17 }, ticks: { beginAtZero: false, steps: 10, stepValue: 1 } }],
    },
    title: { display: false, text: 'Tennis Composition' }
  };
  public barChartLabels11: any = ['2021 Sem3', '2022 Sem1', '2022 Sem2', '2022 Sem3'];
  public barChartType11: any = 'bar';
  public barChartLegend11 = true;
  public barChartPlugins11 = [];
  public barChartData11: ChartDataSets[] = [
    { data: [30, 45, 30, 29], label: 'New', backgroundColor: 'red', order: 2 },
    { data: [5, 2, 0, 5], label: 'Existing', backgroundColor: '#FFA500', order: 2 },
    { data: [-5, -2, -1, -5], label: 'Leaving', backgroundColor: '#FFA500', order: 2 },
  ];
  public chartColors11: any[] = [
    {
      backgroundColor: ["#0a5394", "#0a5394", "#0a5394", "#0a5394"]
    },
    {
      backgroundColor: ["#3c85c6", "#3c85c6", "#3c85c6", "#3c85c6"]
    },
    {
      backgroundColor: ["#ca0001", "#ca0001", "#ca0001", "#ca0001"]
    }
  ];

  //Acedemic chart - Class Mix Analysis
  public barChartOptions12: ChartOptions = {
    responsive: true,
    legend: {
      display: true, position: 'top', labels: {
        fontSize: 17, filter: function (legendItem, data) {
          return legendItem.index != 0;
        }
      }
    },
    scales: {},
    title: { display: false, text: 'Tennis Composition' }
  };
  public barChartLabels12: any = ['1A', '2A', '2B', '2C', '2D'];
  public barChartType12: any = 'pie';
  public barChartLegend12 = true;
  public barChartPlugins12 = [];
  public barChartData12: ChartDataSets[] = [
    { data: [0, 20, 15, 30, 35], label: 'New', backgroundColor: 'red', order: 2 },
    { data: [100, 0, 0, 0, 0], label: 'Existing', borderColor: '#0a0a0a', order: 2 },
  ];
  public chartColors12: any[] = [
    {
      backgroundColor: ["#0a0a0a", "#0a5394", "#3c85c6", "#70a8dc", "#a4c2f4"]
    },
    {
      backgroundColor: ["#0a0a0a", "#0a5394", "#3c85c6", "#70a8dc", "#a4c2f4"]
    }
  ];



  //Higher ed - Individual Performance Tier
  public barChartOptions13: ChartOptions = {
    responsive: true,
    legend: { display: false, position: 'top', labels: { fontSize: 17 } },
    scales: {
      xAxes: [{ display: true, stacked: true, scaleLabel: { display: true, labelString: 'Score Range', fontSize: 17 } }],
      yAxes: [{ display: true, stacked: true, scaleLabel: { display: true, labelString: 'No. of students', fontSize: 17 }, ticks: { beginAtZero: false, steps: 10, stepValue: 1 } }],
    },
    title: { display: false, text: 'Tennis Composition' }
  };
  public barChartLabels13: any = ['0-10', '10-20', '20-30', '30-40', '40-50', '50-60', '60-70', '70-80', '80-90', '90-100']; // Ranges
  public barChartType13: any = 'bar';
  public barChartLegend13 = true;
  public barChartPlugins13 = [];
  public barChartData13: ChartDataSets[] = [
    { data: [2, 5, 10, 26, 60, 61, 25, 11, 4, 1], label: 'Student Performance', backgroundColor: 'red', order: 2 },// StudentCounts
  ];
  public chartColors13: any[] = [
    {
      backgroundColor: ["#c2e0f5", "#87b5d7", "#3c99c7", "#1985bd", "#0d6b9d", "#0d6b9d", "#fc1413", "#3c99c7", "#87b5d7", "#c2e0f5"]
    }
  ];





  //Higher ed - Module Uptake
  public barChartOptions14: ChartOptions = {
    responsive: true,
    legend: { display: true, position: 'top', labels: { fontSize: 17 } },
    scales: {
      xAxes: [{ display: true, scaleLabel: { display: true, labelString: 'Year', fontSize: 17 } }],
      yAxes: [{ display: true, scaleLabel: { display: true, labelString: 'No. of students', fontSize: 17 }, ticks: { beginAtZero: true, steps: 10, stepValue: 1 } }],
    },
    title: { display: false, text: 'Tennis Composition' }
  };
  public barChartLabels14: any = ['2017', '2018', '2019', '2020', '2021', '2022'];
  public barChartType14: any = 'bar';
  public barChartLegend14 = true;
  public barChartPlugins14 = [];
  public barChartData14: ChartDataSets[] = [
    { data: [5, 5, 4, 5, 5, 4], label: 'Business Management', backgroundColor: 'red', order: 2 },
    { data: [6, 6, 7, 7, 6, 8], label: 'Advanced Mathematics', backgroundColor: 'red', order: 2 },
    { data: [5, 3, 4, 8, 10, 12], label: 'Industrial Statistics', backgroundColor: 'red', order: 2 },
  ];
  public chartColors14: any[] = [
    {
      backgroundColor: ["#4e81bd", "#4e81bd", "#4e81bd", "#4e81bd", "#4e81bd", "#4e81bd"]
    },
    {
      backgroundColor: ["#c0504d", "#c0504d", "#c0504d", "#c0504d", "#c0504d", "#c0504d"]
    },
    {
      backgroundColor: ["#9cbb59", "#9cbb59", "#9cbb59", "#9cbb59", "#9cbb59", "#9cbb59"]
    }
  ];


  //Higher ed - Performance vs. Starting Salary
  public scatterChartData3: ChartDataSets[] = [
    {
      data: [
        { x: 55, y: 72000 },
        { x: 58, y: 90000 },
        { x: 65, y: 70000 },
        { x: 67, y: 120000 },
        { x: 70, y: 98000 },
        { x: 70, y: 180000 },
        { x: 80, y: 100000 },
        { x: 83, y: 150000 },
        { x: 90, y: 190000 },
        { x: 92, y: 250000 },
      ], label: 'Performance vs. Starting Salary', backgroundColor: "#00a8d6"
    }
  ];

  public scatterChartLabels3: any = [];
  public scatterChartType3 = 'scatter';
  public scatterChartLegend3 = true;
  public scatterChartPlugins3 = [];
  public scatterChartOptions3: (ChartOptions & { annotation: any }) = {
    responsive: true,
    elements: { point: { radius: 8, hoverRadius: 10, hitRadius: 10 } },
    legend: { display: true, position: 'top', labels: { fontSize: 17 } },
    scales: {
      xAxes: [{ display: true, offset: 10, gridLines: false, scaleLabel: { display: true, labelString: 'Degree Score', fontSize: 17 }, ticks: { beginAtZero: false, steps: 10, stepValue: 1, callback: function (value) { return (value).toFixed(0) + '%'; } } }],
      yAxes: [{ display: true, scaleLabel: { display: true, labelString: 'Monthly Salary (Rs)', fontSize: 17 }, ticks: { beginAtZero: true, steps: 10, stepValue: 1, reverse: false, min: 0 } }]
    },
    title: { display: false, text: 'Performance vs. Starting Salary' }
  };



  //Higher ed - Legacy A/L performance of undergraduates
  public barChartOptions15: ChartOptions = {
    responsive: true,
    legend: { display: true, position: 'right', labels: { fontSize: 17 } },
    scales: {},
    title: { display: true, text: 'Batch Composition', fontSize: 17 }
  };
  public barChartLabels15: any = ['3A+', '2A+', '1A+', '3B+', '2B+', '1B+', '3Cs', '1+ yrs WE'];
  public barChartType15: any = 'pie';
  public barChartLegend15 = true;
  public barChartPlugins15 = [];
  public barChartData15: ChartDataSets[] = [
    { data: [5, 9, 17, 20, 20, 15, 5, 9], label: 'New', backgroundColor: 'red', order: 2 }
  ];
  public chartColors15: any[] = [
    {
      backgroundColor: ["#0a5394", "#3c85c6", "#9fc3e8", "#f1c032", "#ffd966", "#f79645", "#c0504d", "#000000"]
    }
  ];

  //Higher ed - Final degree classification vs. legacy A/L performance
  public barChartOptions16: ChartOptions = {
    responsive: true,
    legend: { display: true, position: 'right', labels: { fontSize: 17 } },
    scales: {},
    title: { display: false, text: 'Batch Composition', fontSize: 17 }
  };
  public barChartLabels16: any = ['A', 'B', 'C', 'D'];
  public barChartType16: any = 'pie';
  public barChartLegend16 = true;
  public barChartPlugins16 = [];
  public barChartData16: ChartDataSets[] = [
    { data: [70, 15, 15, 0], label: 'New', backgroundColor: 'red', order: 2 }
  ];
  public chartColors16: any[] = [
    {
      backgroundColor: ["#4e81bd", "#c0504d", "#9cbb59", "#c6c6c4"]
    }
  ];

  //Higher ed - Final degree classification vs. legacy A/L performance
  public barChartOptions17: ChartOptions = {
    responsive: true,
    legend: { display: true, position: 'right', labels: { fontSize: 17 } },
    scales: {},
    title: { display: false, text: 'Batch Composition', fontSize: 17 }
  };
  public barChartLabels17: any = ['A', 'B', 'C', 'D'];
  public barChartType17: any = 'pie';
  public barChartLegend17 = true;
  public barChartPlugins17 = [];
  public barChartData17: ChartDataSets[] = [
    { data: [55, 25, 25, 0], label: 'New', backgroundColor: 'red', order: 2 }
  ];
  public chartColors17: any[] = [
    {
      backgroundColor: ["#4e81bd", "#c0504d", "#9cbb59", "#c6c6c4"]
    }
  ];


  //Higher ed - Graduate Industry Placement
  public barChartOptions18: ChartOptions = {
    responsive: true,
    legend: { display: false, position: 'top', labels: { fontSize: 17 } },
    scales: {
      xAxes: [{ display: true, scaleLabel: { display: true, labelString: 'Field', fontSize: 17 } }],
      yAxes: [{ display: true, scaleLabel: { display: true, labelString: '# of graduates', fontSize: 17 }, ticks: { beginAtZero: false, steps: 10, stepValue: 1 } }],
    },
    title: { display: false, text: 'Tennis Composition' }
  };
  public barChartLabels18: any = ['Finance', 'Engineering', 'Medicine', 'Business Management', 'Computer Science', 'Own Business', 'Other'];
  public barChartType18: any = 'bar';
  public barChartLegend18 = true;
  public barChartPlugins18 = [];
  public barChartData18: ChartDataSets[] = [
    { data: [5, 12, 2, 25, 5, 0, 12], label: 'New', backgroundColor: 'red', order: 2 },
  ];
  public chartColors18: any[] = [
    {
      backgroundColor: ["#4e81bd", "#4e81bd", "#4e81bd", "#4e81bd", "#4e81bd", "#4e81bd", "#4e81bd"]
    }
  ];



  //teachers charts
  public barChartOptions19: ChartOptions = {
    responsive: true,
    legend: {
      display: true,
      labels: { fontSize: 17 }
    },
    scales: {
      xAxes: [{
        display: true,
        scaleLabel: {
          display: true,
          labelString: 'Year',
          fontSize: 17
        }
      }],
      yAxes: [{
        display: true,
        scaleLabel: {
          display: true,
          labelString: 'Percentage',
          fontSize: 17
        },
        ticks: {
          beginAtZero: true,
          //steps: 10,
          //stepValue: 1,
          reverse: false,
          callback: function (value) {
            return (value).toFixed(0) + '%'; // convert it to percentage
          },
          //min: 1,
          //max: 100
        }
      }]
    }
  };
  public barChartLabels19: any = ['2021', '2022', '2023'];
  public barChartType19: any = 'bar';
  public barChartLegend19 = true;
  public barChartPlugins19 = [];

  public barChartData19: ChartDataSets[] = [
    { data: [22, 15, 20], label: 'A', order: 4 },
    { data: [25, 32, 30], label: 'B', order: 3 },
    { data: [46, 41, 35], label: 'C', order: 2 },
    { data: [5, 13, 15], label: 'Fail', order: 1 },
  ];


  public barChartOptions20: ChartOptions = {
    responsive: true,
    legend: {
      display: true,
      labels: { fontSize: 17 }
    },
    scales: {
      xAxes: [{
        display: true,
        scaleLabel: {
          display: true,
          labelString: 'Year',
          fontSize: 17
        }
      }],
      yAxes: [{
        display: true,
        scaleLabel: {
          display: true,
          labelString: 'Percentage',
          fontSize: 17
        },
        ticks: {
          beginAtZero: true,
          //steps: 10,
          //stepValue: 1,
          reverse: false,
          callback: function (value) {
            return (value).toFixed(0) + '%'; // convert it to percentage
          },
          //min: 1,
          max: 100
        }
      }]
    }
  };
  public barChartLabels20: any = ['2019', '2020', '2021', '2022', '2023'];
  public barChartType20: any = 'bar';
  public barChartLegend20 = true;
  public barChartPlugins20 = [];

  public barChartData20: ChartDataSets[] = [
    { data: [50, 60, 30, 70, 90], label: 'Percentage', order: 4 }
  ];

  public chartColors20: any[] = [
    {
      backgroundColor: ["#4e81bd", "#4e81bd", "#4e81bd", "#4e81bd", "#4e81bd"]
    }
  ];


  public parent_email: string = "";

  public grades: any = ['Grade 6', 'Grade 7', 'Grade 8'];
  public chartsems: any = ['Sem1 2020', 'Sem2 2020', 'Sem3 2020', 'Sem1 2021', 'Sem2 2021', 'Sem3 2021'];
  public chartsems2: any = ['2021 Semester 2 Gr5', '2022 Semester 2 Gr5'];
  public chartsems3: any = ['2020 Semester 1 | Grade 7', '2020 Semester 2 | Grade 7', '2020 Semester 3 | Grade 7', '2021 Semester 1 | Grade 8', '2021 Semester 2 | Grade 8', '2021 Semester 3 | Grade 8'];

  public rank_labels: any = [];

  public subject1: string = "Maths";
  public subject2: string = "Science";

  public isCollapsed = false;


  public YearData: any = [];
  public selectedYear: any;
  public selectedPastYear: any;
  yearId: any = [];
  yearname: any = [];
  nameofstudent: any = [];
  studentId: any = [];
  public childMapId: any = [];
  SchoolDetailsaddress: any = [];
  schoolName: any;
  public Address: any;
  public City: any;
  public Pincode: any;
  public PrimaryPhonenumber: any;
  public WebsiteLink: any;
  public Email: any;
  public Logo: any;
  public RegNo: any;
  public attachment;
  public imgUrl1: string;
  public TeacherNames: any = [];
  standardId: any;
  nameofsem: any = [];
  public selectedTest: any;
  testId: any = [];
  nameoftest: any = [];
  selectedSemester: any = [];
  selectedGrade2: any = [];
  LevelsData: any = [];
  public selectedLevels: any;
  selectedSubSubject: any;
  subSubjectData: any = [];
  selectedSubject2: any;
  public url_segment: string = "";

  selectedTermCoRelation: string = "Term 2";

  //jaliya
  public HigherEdchildcourse: any;
  public selectedCourse: string = '';

  public HigherEdchildbatch: any;
  public selectedBatch: string = '';

  public HigherEdchildsemester: any;
  public HselectedSemester: string = '';

  public HigherEdchildinfo: any;
  public selectedinfo: string = '';

  public HigherEdchildexam: any;
  public selectedExam: string = '';

  public HigherEdchildmodule: any;
  public selectedmodule: string = '';

  public HiEduSubSubjectMarksChart: any;
  public SelectSubSubjectMarksChart: string = '';

  public HiEduGetAllSubjectMarksChart: any;
  public SelectAllSubjectMarksChart: string = '';

  public HiEduGetAverageSubjectMarksChart: any;
  public SelectAverageSubjectMarksChart: string = '';

  public HigherEdModuleStudentPerformanceScoreChart: any;
  public SelectModuleStudentPerformanceScoreChart: string = '';




  public selectedSubjectName: string;

  selectedYears = "2021";
  selectedMonth = "1";
  selectedDay = "1";




  constructor(private dataAnalyticsService: DataAnalyticsService, public router: Router, private route: ActivatedRoute, private _parentData: ParentDataService, private localStorage: LocalStorageService,private changeDetector: ChangeDetectorRef) {

  }

  ngOnInit() {



    //this.userId = this.localStorage.retrieve('ParentPortalParentId');
    //this.CurrentChild = this.localStorage.retrieve('CurrentChild');
    const segments = window.location.href.split("/");
    this.url_segment = segments.pop() || segments.pop();
    console.log("last_url_segment", this.url_segment);

    console.log("ngOnInit schoolId", this.localStorage.retrieve('schoolId'));
    //this.parent_email = this.localStorage.retrieve("ParentEmailOrPhone");
    //this.selectedGrade2 = { standardsName: this.CurrentChild.Standard };
    this.selectedSubject = "All Subjects";
    this.parent_email = 'admin@abc.com';

    //this.CurrentChild.ChildId = 6354;
    //this.CurrentChild.StandardId = 1973;
    //this.CurrentChild.SectionId = 1974;

    if (this.parent_email == "admin@abc.com") {
      this.getYearData();
      this.getLevels();
      this.getTeacherDetails();
    } else if (this.parent_email == "lecturer@abc.com") {
      //jaliya
      this.GetCourseList();
      this.GetSemesterList();
      this.GetBatchList();
      this.HigherEdChildinfo();
      this.GetExamsList();
      this.GetModuleList();

      this.HiEduSubSubjectMarksCharts();
      this.HiEduGetAllSubjectMarksCharts();
      this.HiEduGetAverageSubjectMarksCharts();
      this.HiEduModuleStudentPerformanceScoreChart();




    }
    /*
    if(this.parent_email == "parent@abc.com"){
      this.subjects = ["All Subjects","English","Drama","Religion","Social","Music","Maths","Civics"];
      this.onSubjectOrClassGradeChange(this.selectedSubject, this.selectedGCl);
    this.getSubjects(this.CurrentChild.SectionId);
    this.getYearData();
    }else if(this.parent_email == "admin@abc.com" && this.url_segment == "student-analytics"){
      this.subjects = ["English"];
      this.selectedSubject = "English";
      this.selectedTeacher = "Wethimuni";
      this.onTeacherChange(this.selectedTeacher);
       this.getSubjects(this.CurrentChild.SectionId);
      this.getYearData();
    }else if(this.parent_email == "admin@abc.com" && this.url_segment != "student-analytics"){
    this.subjects = ["English"];
    this.selectedSubject = "English";
    this.selectedTeacher = "Wethimuni";
    this.onTeacherChange(this.selectedTeacher);
    this.getYearData();
    }else if(this.parent_email == "teacher1@abc.com"){
      this.subjects = ["English"];
      this.selectedSubject = "English";
      this.selectedTeacher = "Wethimuni";
      this.onTeacherChange(this.selectedTeacher);
    }else if(this.parent_email == "teacher2@abc.com"){
      this.subjects = ["History"];
      this.selectedSubject = "History";
      this.selectedTeacher = "Lakmal";
      this.onTeacherChange(this.selectedTeacher);
    }else if(this.parent_email == "teacher3@abc.com"){
      this.subjects = ["Maths","IT"];
      this.selectedSubject = "Maths";
      this.selectedTeacher = "Ashoka";
      this.onTeacherChange(this.selectedTeacher);
    }else{
      this.subjects = ["All Subjects","English","Drama","Religion","Social","Music","Maths","Civics"];
      this.getSubjects(this.CurrentChild.SectionId);


      this.getYearData();
    }*/
  }
  /*------------------------------------------  Hiedu Chart --------------------------------------------------------------------------*/

  changeSubjectCorrelationBetweenSubjects(subj1, subj2) {
      console.log("subjects", subj1, subj2);
      this.dataAnalyticsService.GetCorrelationBetweenSubjects(subj1.SubjectId, subj2.SubjectId,this.selectedGrade.standardId, this.selectedTest.TestId).finally(() => { }).subscribe(
        response => {
          let correlationBetweenSubjects: any = [];
          correlationBetweenSubjects = response;
          console.log('CorrelationBetweenSubjects', correlationBetweenSubjects);
          this.scatterChartLabels = [];

          this.scatterChartOptions = {
            responsive: true,
            legend: { display: true, position: 'top', labels: { fontSize: 17 } },
            scales: {
              x: {
                display: true,
                type: 'linear',
                position: 'bottom',
              },
              xAxes: [{
                display: true,
                scaleLabel: {
                  display: true,
                  labelString: subj1.SubjectName,
                  fontSize: 17
                },
                ticks: {
                  beginAtZero: true,
                  min: 0,
                  max: 100,
                  callback: function (value) {
                    return (value).toFixed(0) + '%'; // convert it to percentage
                  },
                }
              }],
              yAxes: [{
                display: true,
                scaleLabel: {
                  display: true,
                  labelString: subj2.SubjectName,
                  fontSize: 17
                },
                ticks: {
                  beginAtZero: true,
                  min: 0,
                  max: 100,
                  callback: function (value) {
                    return (value).toFixed(0) + '%'; // convert it to percentage
                  },
                }
              }]
            }
        };

          let subject1Array = correlationBetweenSubjects.Subject1GradeMarksPrecentageArray;
          let subject2Array = correlationBetweenSubjects.Subject2GradeMarksPrecentageArray;

          let final_array = subject1Array.map((item, index) => {
            return {
                x: item,
                y: subject2Array[index]
            };
          });

          this.scatterChartData = [
            { data: final_array, label: subj1.SubjectName + ' (x-axis) vs. ' + subj2.SubjectName + ' (y-axis)', backgroundColor: 'blue' },
          ];




          this.scatterChartLabels = [subj1.SubjectName, subj2.SubjectName];
        },
        error => {
            this.scatterChartData = [
              { data: [], label: subj1.SubjectName + ' (x-axis) vs. ' + subj2.SubjectName + ' (y-axis)', backgroundColor: 'blue' },
            ];
            this.scatterChartLabels = [];
          console.error('CorrelationBetweenSubjects', error);
        });
  }


  //------------------------------------------------------------------------------------------------
  private getTeacherDetails() {
    this.dataAnalyticsService.getTeacherList().finally(() => { }).subscribe(
      response => {
          console.log('getTeacherDetails', response["teacherdetailList"]);
        this.teachers = response["teacherdetailList"];
        try {
            this.selectedTeacher = this.teachers[0];
        } catch (error) {

        }

      },
      error => {
        this.teachers = [];
        console.error(error);
      });
  };


  private HigherEdChildinfo() {
    this.dataAnalyticsService.getHiEduChildInfo(this.selectedCourse, this.selectedBatch).finally(() => { }).subscribe(
      response => {
        this.HigherEdchildinfo = response;
        console.log('HigherEdchildinfo', this.HigherEdchildinfo)
      },
      error => {
        this.HigherEdchildinfo = [];
        console.error(error);
      });
  };

  changeChildInfo() {
    console.log("ChildInfo", this.selectedinfo)
    //this.GetSemesterList();


  };

  private GetExamsList() {
    this.dataAnalyticsService.getHigherEdChildExamList(this.selectedCourse, this.HselectedSemester).finally(() => { }).subscribe(
      response => {
        this.HigherEdchildexam = response['Value'];
        try {
            this.selectedExam = this.HigherEdchildexam[0].examid;
        } catch (error) {

        }
        this.HiEduGetAllSubjectMarksCharts();
        this.HiEduGetAverageSubjectMarksCharts();
        console.log('HigherEdchildexam', this.HigherEdchildexam)
      },
      error => {
        console.error(error);
      });
  };

  changeexam(selectedExam) {
    console.log("exam", selectedExam)
    this.HiEduGetAverageSubjectMarksCharts();
    this.HiEduGetAllSubjectMarksCharts();
    this.GetModuleList();


  };


  private GetCourseList() {
    this.dataAnalyticsService.getHigherEdChildCourseList().finally(() => { }).subscribe(
      response => {
        this.HigherEdchildcourse = response['items'];

        console.log('HigherEdchildcourse', this.HigherEdchildcourse)
      },
      error => {
        console.error(error);
      });
  };

  changecourse(selectedCourse) {
    console.log("courseT", selectedCourse)
    this.GetBatchList();
    this.GetSemesterList();




  };

  private GetModuleList(){
    this.dataAnalyticsService.getHigherEdChildSubjectList(this.selectedCourse,this.HselectedSemester,this.selectedExam).finally(() => { }).subscribe(
      response => {
   this.HigherEdchildmodule = response['Value'];
        console.log('HigherEdchildmodule',this.HigherEdchildmodule)
      },
      error => {
        console.error(error);
      });
  };

  // changedmodule(selectedmodule) {
  //   console.log("module",selectedmodule)
  //   this.HiEduSubSubjectMarksCharts()


  // };



  private GetBatchList() {
    this.dataAnalyticsService.getHigherEdChildBatchList(this.selectedCourse).finally(() => { }).subscribe(
      response => {
        this.HigherEdchildbatch = response['Value'];
        console.log('HigherEdchildbatch', this.HigherEdchildbatch)
      },
      error => {
        console.error(error);
      });
  };


  changebatch(selectedBatch) {
    console.log("batch", selectedBatch)
    //this.HigherEdChildinfo()
  };




  private GetSemesterList() {
    this.dataAnalyticsService.getHigherEdChildSemesterList(this.selectedCourse).finally(() => { }).subscribe(
      response => {
        this.HigherEdchildsemester = response;
        console.log('HigherEdchildSemester', this.HigherEdchildsemester)
      },
      error => {
        console.error(error);
      });
  };

  changesemester(HselectedSemester) {
    console.log("semesterT", HselectedSemester)
    this.GetExamsList();


    //this.HiEduGetAllSubjectMarksCharts();
    //this.HiEduGetAverageSubjectMarksCharts();
    //this.clearRadarChart();
  };


  //Hiedu Sub Subject Chart
  changedmodule(selectedmodule) {
    this.dataAnalyticsService.getHigherEdSubSubjectMarksList(this.selectedinfo, selectedmodule).subscribe(
      response => {
        this.updateChartData(response);
        this.HiEduSubSubjectMarksCharts();
        this.HiEduModuleStudentPerformanceScoreChart();
      },
      error => {
        console.error(error);
      });
  }


  updateChartData(data) {
    this.barChartLabelsSHedu = [];
    this.barChartDataSHedu[0].data = [];
    this.barChartLabelsSHedu = data.map(item => item.SubSubjectName);
    this.barChartDataSHedu[0].data = data.map(item => item.Marks);
    this.changeDetector.detectChanges();
}


//Get HiEduSubSubjectMarksForStudent

private HiEduSubSubjectMarksCharts() {
  this.dataAnalyticsService.getHigherEdSubSubjectMarksList(this.selectedinfo, this.selectedmodule).finally(() => { }).subscribe(
    response => {
      this.HiEduSubSubjectMarksChart = response;
      console.log('HiEduSubSubjectMarksChart', this.HiEduSubSubjectMarksChart)
    },
    error => {
      console.error(error);
    });
};

changeSubSubjectMarksChart() {
  console.log("subsubjectmarkschart",this. SelectSubSubjectMarksChart)

};



  //Hiedu Rader Chart

  //   private HiEduGetAverageSubjectMarksCharts() {
  //     this.dataAnalyticsService.getHigherEdAverageSubjectMarksList(this.selectedCourse,this.selectedBatch,this.HselectedSemester,this.selectedExam).finally(() => { }).subscribe(
  //       response => {
  //         this.HiEduGetAverageSubjectMarksChart = response;
  //         console.log('HiEduGetAverageSubjectMarks', this.HiEduGetAverageSubjectMarksChart)

  //         // Map over the subjects from the first API response and find the corresponding average score
  //         this.radarChartDataH[1].data = this.radarChartLabelsH.map(subject => {
  //           const subjectData = this.HiEduGetAverageSubjectMarksChart.find(x => x.Subject === subject);
  //           return subjectData ? subjectData.AverageScore : 0; // if the subject is not found in the response, return 0
  //         });

  //       },
  //       error => {
  //         console.error(error);
  //       });
  //   };


  // private HiEduGetAllSubjectMarksCharts() {
  //   this.dataAnalyticsService.getHigherEdallsubjectMarksList(this.selectedinfo, this.selectedExam).finally(() => { }).subscribe(
  //     response => {
  //       this.HiEduGetAllSubjectMarksChart = response;
  //       console.log('HiEduGetAllSubjectMarksChart', this.HiEduGetAllSubjectMarksChart)

  //       // assuming response is an array of objects with SubjectName and Marks properties
  //       this.radarChartLabelsH = this.HiEduGetAllSubjectMarksChart.map(x => x.SubjectName); // extract the subject names
  //       this.radarChartDataH[0].data = this.HiEduGetAllSubjectMarksChart.map(x => x.Marks); // extract the marks
  //     },
  //     error => {
  //       console.error(error);
  //     });
  // };

  private HiEduGetAllSubjectMarksCharts() {
    this.dataAnalyticsService.getHigherEdallsubjectMarksList(this.selectedinfo, this.selectedExam).finally(() => { }).subscribe(
      response => {
        this.HiEduGetAllSubjectMarksChart = response;
        console.log('HiEduGetAllSubjectMarksChart', this.HiEduGetAllSubjectMarksChart)

        // assuming response is an array of objects with SubjectName and Marks properties
         // extract the subject names
         this.radarChartLabelsH = [];
        this.radarChartDataH[0].data = this.HiEduGetAllSubjectMarksChart.map(x => x.Marks); // extract the marks
        this.radarChartLabelsH = this.HiEduGetAllSubjectMarksChart.map(x => x.SubjectName);
        // Call the second function here
        //this.HiEduGetAverageSubjectMarksCharts();
      },
      error => {
          this.radarChartLabelsH = [];
          this.radarChartDataH[0].data = [];
        console.error(error);
      });
  };

  private clearRadarChart(){
      this.radarChartLabelsH = [];
      this.radarChartDataH[0].data = [];
      this.radarChartDataH[1].data = [];
  }

  private HiEduGetAverageSubjectMarksCharts() {
    this.dataAnalyticsService.getHigherEdAverageSubjectMarksList(this.selectedCourse, this.selectedBatch, this.HselectedSemester, this.selectedExam).finally(() => { }).subscribe(
      response => {
        this.HiEduGetAverageSubjectMarksChart = response;
        console.log('HiEduGetAverageSubjectMarks', this.HiEduGetAverageSubjectMarksChart)

        // Map over the subjects from the first API response and find the corresponding average score
        /*this.radarChartDataH[1].data = this.radarChartLabelsH.map(subject => {
          const subjectData = this.HiEduGetAverageSubjectMarksChart.find(x => x.Subject === subject);
          return subjectData ? subjectData.AverageScore : 0; // if the subject is not found in the response, return 0
      });*/

        let radar_data: any = [];
        let chart_labels: any = [];
        chart_labels = [...this.radarChartLabelsH];
        this.HiEduGetAverageSubjectMarksChart.forEach(element => {
            radar_data.push(element.AverageScore);
        });

        this.radarChartDataH[1].data = radar_data;
        this.radarChartLabelsH = chart_labels;

      },
      error => {
          this.radarChartLabelsH = [];
          this.radarChartDataH[1].data = [];
        console.error(error);
      });
  };



  //Get HieduModuleStudentPerformanceScore Chart

  private HiEduModuleStudentPerformanceScoreChart() {
    this.dataAnalyticsService.getHigherEdModuleStudentPerformanceScoreList(this.selectedBatch, this.HselectedSemester,this.selectedExam,this.selectedmodule).subscribe(
      (response: any[]) => {
        this.HigherEdModuleStudentPerformanceScoreChart = response;
        console.log('HigherEdModuleStudentPerformanceScoreChart', this.HigherEdModuleStudentPerformanceScoreChart);

        // Format the data for the chart
        this.barChartLabels13 = response.map(item => item.Range);
        this.barChartData13 = [
          {
            data: response.map(item => item.StudentCount),
            label: 'Student Performance'
          }
        ];
      },
      error => {
        console.error(error);
      });
  }






  //------------------------------------------------------------------------------------------------

  private getOverallSubjectMarksOverallRankByGrade(subId, stdId, testId, academicYearId) {
    this.dataAnalyticsService.GetOverallSubjectMarksOverallRankByGrade(subId, stdId, testId, academicYearId)._finally(() => { this.loading = "none" }).subscribe(
      response => {
        let data: any;
        console.log("getOverallSubjectMarksOverallRankByGrade", response);
        data = response;
        this.scatterChartLabels2 = [];
        let processed_data = [];
        for (let index = 0; index < data.Subject1GradeMarksPrecentageArray.length; index++) {
          const element = data.Subject1GradeMarksPrecentageArray[index];
          const element2 = data.OverallRankArray[index];
          processed_data.push({ x: element2, y: element });
        }
        this.scatterChartData2[0].data = processed_data;
        this.scatterChartData2[0].label = this.selectedSubject['SubjectName'] + " vs Class Position";
        this.scatterChartLabels2 = ['Maths'];
        //console.log("getOverallSubjectMarksOverallRankByGrade", this.scatterChartData2[0].data);
      }
    );
  }

  onChangeSelectedTermCoRelation(t) {
    console.log("Term", t);
    this.scatterChartLabels = [];
    if (t == "Term 2") {
      this.scatterChartData[0].data = this.data1;
    } else {
      this.scatterChartData[0].data = this.data2;
    }
    this.scatterChartData[0].label = "Maths" + " vs " + "Science";
    this.scatterChartLabels = ['Sem1 20 Gr7', 'Sem2 20 Gr7', 'Sem3 20 Gr7', 'Sem1 21 Gr8', 'Sem2 21 Gr8', 'Sem3 21 Gr8'];
  }

  goToDRC() {
    this.router.navigate([`parent/${this.CurrentChild.ChildId}/digital-report-card`]);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  private getSubSubjectsById(level) {
    console.log("getSubSubjectsById", level);

    if (level.SubjectId == "all-subjects") {
      //this.GetStudentsChartOverallPrecentageRank(childidx);
      //return;
    } else if (level.SubjectId != undefined) {
      //this.getSubSubjectRankByClass();
    }

  }

  private getSubSubjects(subid) {
    this.dataAnalyticsService.GetSubSubjects(subid)._finally(() => { this.loading = "none" }).subscribe(
      response => {
        console.log("getSubSubjects", response);
        this.subSubjectData = response;
        try {
          this.selectedSubSubject = this.subSubjectData[0];

          if (this.selectedSubSubject.SubjectId == "all-subjects") {
            //this.GetStudentsChartOverallPrecentageRank(childidx);
            //return;
          } else if (this.selectedSubSubject.SubjectId != undefined) {
            //this.getSubSubjectRankByClass();
          }
        } catch (error) {

        }

      }
    );
  }


  private getLevelsListById(level) {
    console.log("getLevelsListById", level);
    this.getLevelClassSection(level["Id"]);
  }


  private getLevels() {
    this.dataAnalyticsService.GetLevels()._finally(() => { this.loading = "none" }).subscribe(
      response => {
        console.log("getLevels", response);
        this.LevelsData = response;
        try {
          this.selectedLevels = this.LevelsData[0];
          this.getLevelClassSection(this.selectedLevels["Id"]);
        } catch (error) {

        }
      }
    );
  }


  onSubjectChangeRadar(subject) {
    this.barChartLabelsS = [];
    this.barChartDataS[0].data = [];
    let found = false;
    this.studentRCData.studentRCInnerModels.forEach(element => {
      if (subject.SubjectName == element.Subject) {
        this.barChartDataS[0].data = element.subsubjectPercentage.map(n => Number(n));
        this.barChartLabelsS = element.SubSubjects;
        found = true;
      }
    });
  }








  private getStudentRecord(StudentId, TestId, YearId) {
    this.studentRCData = [];
    this.dataAnalyticsService.getStudentRC(StudentId, TestId, YearId)._finally(() => { this.loading = "none" }).subscribe(
      response => {
        console.log('getStudentRecord', response)
        this.studentRCData = response[0];
        var rc_labels = [];
        var rc_data = [];
        var rc_avg_data = [];
        this.studentRCData.studentRCInnerModels.sort((a, b) => ("" + a.Subject).localeCompare(b.Subject, undefined, { numeric: true }));
        console.log('studentRC', this.studentRCData)
        this.calculatePercentagesOnTheFly();
        this.studentRCData.studentRCInnerModels.forEach(element => {
          rc_labels.push(element.Subject);
          rc_data.push(element.Percentage);
          rc_avg_data.push(element.GradeStudentsSubjectMarksAverage);
        });
        try {
          this.onSubjectChangeRadar(this.selectedSubject2);
        } catch (error) {

        }

        this.radarChartLabels = [];
        this.radarChartData[0].data = rc_data;
        this.radarChartData[1].data = rc_avg_data.map(num => Math.round(num * 100) / 100);

        /*
        var classA_term2_marks = [70, 75, 65, 50, 85, 75, 80, 75, 70, 80, 75, 80, 75, 70, 85, 80, 70, 75, 80, 75];
        var classA_term3_marks = [75, 60, 70, 85, 80, 75, 80, 75, 70, 80, 75, 80, 75, 70, 85, 80, 75, 70, 80, 75];

        var classB_term2_marks = [65, 70, 75, 80, 75, 70, 75, 80, 70, 75, 80, 75, 70, 75, 80, 75, 70, 75, 80, 75];
        var classB_term3_marks = [70, 75, 80, 75, 70, 51, 80, 75, 70, 75, 80, 75, 70, 75, 80, 75, 70, 75, 80, 75];

        var classC_term2_marks = [80, 75, 85, 75, 80, 75, 80, 75, 70, 75, 80, 75, 70, 85, 75, 80, 75, 70, 75, 80];
        var classC_term3_marks = [55, 80, 75, 85, 75, 80, 75, 80, 70, 75, 80, 75, 70, 85, 80, 75, 70, 75, 80, 75];


        try {
          if(this.selectedSection.sectionName == "A" && this.selectedSemester.SemesterName == "Term 2"){
            this.radarChartData[1].data = classA_term2_marks.slice(0, rc_data.length);
          }else if (this.selectedSection.sectionName == "A" && this.selectedSemester.SemesterName == "Term 3") {
            this.radarChartData[1].data = classA_term3_marks.slice(0, rc_data.length);
          }else if (this.selectedSection.sectionName == "B" && this.selectedSemester.SemesterName == "Term 2") {
            this.radarChartData[1].data = classB_term2_marks.slice(0, rc_data.length);
          }else if (this.selectedSection.sectionName == "B" && this.selectedSemester.SemesterName == "Term 3") {
            this.radarChartData[1].data = classB_term3_marks.slice(0, rc_data.length);
          }else if (this.selectedSection.sectionName == "C" && this.selectedSemester.SemesterName == "Term 2") {
            this.radarChartData[1].data = classC_term2_marks.slice(0, rc_data.length);
          }else if (this.selectedSection.sectionName == "C" && this.selectedSemester.SemesterName == "Term 3") {
            this.radarChartData[1].data = classC_term3_marks.slice(0, rc_data.length);
          }
        } catch (error) {

        }*/

        this.radarChartLabels = rc_labels;
      }
    );
  }

  calculatePercentagesOnTheFly() {
    this.studentRCData.studentRCInnerModels.forEach(element => {
      let subsubjectPercentage = [];
      for (let i = 0; i < element.SubSubjectMaxMarks.length; i++) {
        let percentage;
        if (element.SubSubjectAbsent[i] == 1) {
          percentage = 0;
        } else {
          percentage = (element.SubSubjectsMarks[i] / element.SubSubjectMaxMarks[i]) * 100;
        }
        subsubjectPercentage.push(percentage.toFixed(2));
      }
      element.subsubjectPercentage = subsubjectPercentage;
      element.Percentage = this.calculateSubjectPercentage(element.SubSubjectsMarks, element.SubSubjectMaxMarks, element.SubSubjectWeight, element.SubSubjectAbsent);
      element.Marks = this.calculateSubjectPercentage(element.SubSubjectsMarks, element.SubSubjectMaxMarks, element.SubSubjectWeight, element.SubSubjectAbsent);
      element.MaxMarks = 100;
    });
    console.log("calculatePercentagesOnTheFly", this.studentRCData);
  }

  private calculateSubjectPercentage(subMarks, maxMarks, weight, absent) {
    let subPercentage = subMarks.map((marks, index) => {
      if (absent[index] == 1) {
        return 0;
      } else {
        return (marks / maxMarks[index]) * 100;
      }
    });

    let totalWeight = weight.reduce((a, b) => a + b, 0);
    let subjectMarks = subPercentage.reduce((acc, curr, index) => {
      return acc + curr * weight[index];
    }, 0);

    return (subjectMarks / totalWeight).toFixed();
  }

  getTestListById(test) {
    //this.printbtn = true;
    console.log(test)
    this.studentRCData = [];
    this.testId = test.TestId;
    this.nameoftest = test.TestName;
    this.getStudentRecord(this.studentId, this.testId, this.selectedYear.YearId);
    //this.getAveragePerformances(this.sectionId,this.testId,this.studentId,this.selectedYear.YearId);
    // this.getSchoolDetailsForRC(this.studentId);
    console.log('ids', this.testId, this.studentId)
    //this.getSubSubjectRankByClass();
  }

  private getTestData(SemesterId) {
    this.dataAnalyticsService.getTest(SemesterId)._finally(() => { }).subscribe(
      response => {
        this.TestData = response["testsList"];
        this.selectedTest = this.TestData[0];
        this.getTestListById(this.selectedTest);

        console.log("this.TestData", this.TestData);
        try {
            this.changeSubjectCorrelationBetweenSubjects(this.subject1, this.subject2);
        } catch (error) {

        }
      }
    )
  }

  getSemesterListById(sem) {
    console.log(sem)
    this.TestData = [];
    this.studentRCData = [];
    this.nameofsem = sem.SemesterName;
    this.selectedTest = "";
    console.log(sem.SemesterName.replace(/[^0-9]/g, ''))
    this.getTestData(sem.SemesterId)
  }

  private getLevelClassSection(lid) {
    this.dataAnalyticsService.GetLevelStandardSectionMapping(lid).finally(() => { }).subscribe(
      response => {
        let mappedData: any = response;
        mappedData.forEach(standard => {
          standard['Sections'].forEach(section => {
            section['StdId'] = standard['standardId'];
            section['StdName'] = standard['standardsName'];
            section['selected'] = false;
          });
        });
        console.log("mappedData", mappedData);
        mappedData.sort((a, b) => ("" + a.standardsName).localeCompare(b.standardsName, undefined, { numeric: true }));
        if (true) {
          this.mappedData = mappedData;

        }

        /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        this.selectedGrade = mappedData.find(data => {
          return data.standardId == this.CurrentChild.StandardId;
        });

        if (this.selectedGrade == null && mappedData.length > 0)
          this.selectedGrade = mappedData[0];

        try {
          this.getSectionByGrade(this.selectedGrade);
        } catch (error) {
          //window.location.reload();
        }

        if (this.selectedGrade != null) this.selectedSection = this.selectedGrade.Sections.find(data => {
          return data.SectionId == this.CurrentChild.SectionId;
        });

        if (this.selectedGrade != null && this.selectedGrade.Sections.length > 0 && this.selectedSection == null)
          this.selectedSection = this.selectedGrade.Sections[0];

        if (this.selectedSection != null)
          this.getSubjects(this.selectedSection.SectionId);
        this.students = [];
        this.NumberOfStudents = [];
        this.SemesterData = [];
        this.TestData = [];
        this.studentRCData = [];
        try {
          this.nameofsec = this.selectedSection.sectionName;
          this.sectionId = this.selectedSection.SectionId;
          this.getStudentListAcedemic(this.selectedGrade.standardId, this.selectedSection.SectionId, this.selectedYear.YearId);
        } catch (error) {

        }

        ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

        /*else {
          this.mappedData = mappedData;
          this.get_userdetailes();
        }*/
      },
      error => {
          this.mappedData = [];
      });
  };

  private getClassSection() {
    this.dataAnalyticsService.getClassSectionMap().finally(() => { }).subscribe(
      response => {
        let mappedData: any = response;
        mappedData.forEach(standard => {
          standard['Sections'].forEach(section => {
            section['StdId'] = standard['standardId'];
            section['StdName'] = standard['standardsName'];
            section['selected'] = false;
          });
        });
        console.log("mappedData", mappedData);
        mappedData.sort((a, b) => ("" + a.standardsName).localeCompare(b.standardsName, undefined, { numeric: true }));
        if (true) {
          this.mappedData = mappedData;

        }



        /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        this.selectedGrade = mappedData.find(data => {
          return data.standardId == this.CurrentChild.StandardId;
        });
        try {
          this.getSectionByGrade(this.selectedGrade);
        } catch (error) {
          //window.location.reload();
        }
        this.selectedSection = this.selectedGrade.Sections.find(data => {
          return data.SectionId == this.CurrentChild.SectionId;
        });
        if (this.selectedSection != null)
          this.getSubjects(this.selectedSection.SectionId);
        this.students = [];
        this.NumberOfStudents = [];
        this.SemesterData = [];
        this.TestData = [];
        this.studentRCData = [];
        this.nameofsec = this.selectedSection.sectionName;
        this.sectionId = this.selectedSection.SectionId;
        this.getStudentListAcedemic(this.selectedGrade.standardId, this.selectedSection.SectionId, this.selectedYear.YearId);
        ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

        /*else {
          this.mappedData = mappedData;
          this.get_userdetailes();
        }*/
      },
      error => {
      });
  };

  private getStudentData(StandardId, SectionId, AcademicYear) {
    this.dataAnalyticsService.getStudents(StandardId, SectionId, AcademicYear)._finally(() => { }).subscribe(
      response => {
        this.students = response['studentsList'];
        console.log(this.students)
        this.NumberOfStudents = response['No_of_Students'];
        // console.log(this.NumberOfStudents )
      }
    )
  }
  /*private getStudentData(StandardId,SectionId,AcademicYear) {
    this.dataAnalyticsService.getStudents(StandardId,SectionId,AcademicYear)._finally(() => { }).subscribe(
      response => {
        this.students = response;
        console.log(this.students)
        this.NumberOfStudents = this.students[0].No_of_Stutents;
         console.log(this.NumberOfStudents )
      }
    )
  }*/

  getGclClassesListById(section) {
    this.students = [];
    this.NumberOfStudents = [];
    this.SemesterData = [];
    this.TestData = [];
    this.studentRCData = [];
    this.nameofsec = section.sectionName;
    this.sectionId = section.SectionId;
    this.getSubjects(section.SectionId);
    this.getStudentData(this.selectedGrade.standardId, this.sectionId, this.selectedYear.YearId);
    console.log('sectionList1', section.sectionName)

    try {
      this.getSemesterData(this.selectedYear.YearId);
    } catch (error) {

    }
  }


  private getSchoolDetailsForRC(studentId) {
    this.dataAnalyticsService.getSchoolDetailsForRC(studentId, this.childMapId)._finally(() => { }).subscribe(
      response => {
        this.SchoolDetailsaddress = response;
        console.log(this.SchoolDetailsaddress)
        this.schoolName = this.SchoolDetailsaddress.SchoolName;
        this.Address = this.SchoolDetailsaddress.Address;
        this.City = this.SchoolDetailsaddress.City;
        this.Pincode = this.SchoolDetailsaddress.Pincode;
        this.PrimaryPhonenumber = this.SchoolDetailsaddress.PrimaryPhonenumber;
        this.WebsiteLink = this.SchoolDetailsaddress.WebsiteLink;
        this.Email = this.SchoolDetailsaddress.Email;
        this.Logo = this.SchoolDetailsaddress.Logo;
        this.RegNo = this.SchoolDetailsaddress.RegNo;
        // console.log(this.schoolName )
        this.attachment = this.imgUrl1 + this.Logo;
        //this.attachment = this.imgUrl1 + this.schoolLogo1;
        // this.EncodedLogo = 'data:image/jpg;base64,' + btoa(this.attachment)
        // console.log(this.attachment )
        this.SchoolDetailsaddress.Teachers.forEach(element => {
          // element["TeacherName"] =element.TeacherName;
          this.TeacherNames = element.TeacherName
          console.log(this.TeacherNames)
          // this.TeacherNames = this.TeacherNames.filter(a=> a.TeacherName == element.TeacherName)
        });
      }
    )
  }

  private getSemesterData(year) {
    this.dataAnalyticsService.getSemester(year)._finally(() => { }).subscribe(
      response => {
        console.log("getSemesterData", response)
        this.SemesterData = response['semestersList'];
        //this.SemesterData = response;
        try {
          this.selectedSemester = this.SemesterData[0];
          this.getSemesterListById(this.selectedSemester);
        } catch (error) {

        }



      }
    )
  }

  getStudentListById(student) {
    this.studentRCData = [];
    this.SemesterData = [];
    this.TestData = [];
    console.log("getStudentListById", student);
    try {
      this.nameofstudent = student["StudentName"];
      this.studentId = student["StudentId"];
      console.log(student["StudentId"])
    } catch (error) {

    }


    this.getSemesterData(this.selectedYear.YearId);

    // this.GetSubjectRankClassStudentCharts(student["StudentId"], this.selectedSubSubject['SubjectId']);
    // this.getStudentRecord(this.studentId);
  }

  private getStudentListAcedemic(standardId, sectionId, yearId) {
    this.dataAnalyticsService.getStudents(standardId, sectionId, yearId)._finally(() => { }).subscribe(
      response => {
        this.students = response["studentsList"];
        console.log(this.students);
        this.NumberOfStudents = response["No_of_Students"];
        this.selectedStudent = this.students.find(data => {
          return data.StudentId == this.CurrentChild.ChildId;
        });
        try {
          if (this.selectedStudent == undefined) this.selectedStudent = this.students[0];
        } catch (error) {

        }

        console.log("this.selectedStudent", this.selectedStudent);
        if (this.selectedStudent == undefined) this.selectedStudent = this.students.find(data => {
          var child_name = this.CurrentChild.ChildLastName + " " + this.CurrentChild.ChildFirstName;
          return data.StudentName == child_name.trim();
        });
        console.log("this.selectedStudent2", this.selectedStudent);
        this.getStudentListById(this.selectedStudent);
        this.getSchoolDetailsForRC(this.studentId);
        this.GetSubjectRankClassStudentCharts(this.studentId, this.selectedSubSubject['SubjectId']);
      }, err => {
        this.loading = 'none';
      }
    );
  }


  getYearList(year) {
    this.students = [];
    this.NumberOfStudents = [];
    this.studentRCData = [];
    this.SemesterData = [];
    this.TestData = [];
    this.studentData = []
    this.yearId = year.YearId;
    this.yearname = year.AcademicYear;
    //this.printbtn = false;

    var sg = this.selectedGrade;
    var ss = this.selectedSection;
    var sl = this.sectionList;
    //var gn = this.nameofstd;

    try {
      var year_difference = Number(this.selectedPastYear.AcademicYear.replace(/[^0-9]/g, '')) - Number(year.AcademicYear.replace(/[^0-9]/g, ''));
      console.log("year_difference", year_difference);
      var new_grade = Number(this.selectedGrade.standardsName.replace(/[^0-9]/g, '')) - year_difference;
      this.selectedGrade = this.mappedData.find(data => {
        return data.standardsName == this.selectedGrade.standardsName.replace(this.selectedGrade.standardsName.replace(/[^0-9]/g, ''), new_grade);
      });
      //this.nameofstd = this.selectedGrade.standardsName
      this.sectionList = this.selectedGrade.Sections;
      this.selectedSection = this.selectedGrade.Sections.find(data => {
        return data.sectionName == this.selectedSection.sectionName;
      });
    } catch (error) {
      this.selectedGrade = sg;
      //this.nameofstd = gn;
      this.sectionList = sl;
      this.selectedSection = ss;
    }

    this.selectedPastYear = year;
    this.getStudentListAcedemic(this.selectedGrade.standardId, this.selectedSection.SectionId, this.selectedYear.YearId);
  }

  private getYearData() {
    this.dataAnalyticsService.getYear()._finally(() => { }).subscribe(
      /*response => {
        this.YearData = response;
        try {
          this.selectedYear = this.YearData[0];
          this.selectedPastYear = this.YearData[0];
        } catch (error) {
        }
        this.getClassSection();
        console.log(this.YearData )
      }*/
      response => {
        this.YearData = response['yearList'];
        this.YearData.sort((a, b) => b.AcademicYear.localeCompare(a.AcademicYear));
        try {
          this.selectedYear = this.YearData[0];
          this.selectedPastYear = this.YearData[0];
        } catch (error) {
        }
        //this.getClassSection();
        console.log(response)
      }
    )
  }



  onTeacherChange(teacher) {
    if (teacher == "Wethimuni") {
      this.subjects = ["English"];
      this.selectedSubject = "English";
    } else if (teacher == "Lakmal") {
      this.subjects = ["History"];
      this.selectedSubject = "History";
    } else if (teacher == "Ashoka") {
      this.subjects = ["Maths", "IT"];
      this.selectedSubject = "Maths";
    }
    console.log("onTeacherChange", teacher);
    this.onSubjectChange(this.selectedSubject);
  }

  toggleCollapse() {
    return;
    //console.log("toggleCollapse", this.isCollapsed);
    //this.isCollapsed = !this.isCollapsed;
  }

  onSubjectChange(subject) {
    if (subject == "English") {
      this.grades = ['Grade 7', 'Grade 8', 'Grade 9'];
      this.selectedGrade2 = "Grade 7";
    } else if (subject == "History") {
      this.grades = ['Grade 8', 'Grade 9', 'Grade 10'];
      this.selectedGrade2 = "Grade 8";
    } else if (subject == "Maths") {
      this.grades = ['Grade 7', 'Grade 9', 'Grade 11'];
      this.selectedGrade2 = "Grade 7";
    } else if (subject == "IT") {
      this.grades = ['Grade 9', 'Grade 10', 'Grade 11'];
      this.selectedGrade2 = "Grade 9";
    }
    console.log("onSubjectChange", subject);
    this.onGradeChange(subject, this.selectedGrade2);
  }

  onSubjectComparisonSubjectChange(subject1, subject2) {
    /*this.scatterChartLabels = [];
    this.scatterChartOptions = {
      responsive: true,
      scales: {
      x: {
        display: true,
        type: 'linear',
        position: 'bottom',
      },
      xAxes: [{
              display: true,
              scaleLabel: {
                  display: true,
                  labelString: this.subject1
              },
              ticks: {
                  beginAtZero: true,
                  min: 0,
                  max: 100
              }
          }],
      yAxes: [{
              display: true,
              scaleLabel: {
                  display: true,
                  labelString: this.subject2
              },
              ticks: {
                  beginAtZero: true,
                  min: 0,
                  max: 100
              }
          }]
    }
    };
    this.scatterChartData[0].data = [];
    for (let index = 0; index < 35; index++) {
      var variation = 30; var min = 30; var max = 100;
      var r1 = Math.floor(Math.random() * (max - min + 1) + min);
      if(r1 + variation > max){
        var r3 = r1;
        var r4 = r1 - Math.floor(Math.random() * (variation - 1 + 1) + 1);
      }else if(r1 - variation < min){
        var r3 = r1 + Math.floor(Math.random() * (variation - 1 + 1) + 1);
        var r4 = r1;
      }else{
        var r3 = r1 + Math.floor(Math.random() * (variation - 1 + 1) + 1);
        var r4 = r1 - Math.floor(Math.random() * (variation - 1 + 1) + 1);
      }
      var r2 = Math.floor(Math.random() * (r3 - r4 + 1) + r4);
      this.scatterChartData[0].data.push({x: r1, y: r2});
    }
    this.scatterChartData[0].label = this.subject1 + " vs " + this.subject2;
    this.scatterChartLabels = ['Sem1 20 Gr7', 'Sem2 20 Gr7', 'Sem3 20 Gr7', 'Sem1 21 Gr8', 'Sem2 21 Gr8', 'Sem3 21 Gr8'];*/
  }

  onGradeChange(subject, grade) {
    if (grade == "Grade 7") {
      //this.chartsems = ['Sem1_20_Gr6', 'Sem2_20_Gr6', 'Sem3_20_Gr6', 'Sem1_21_Gr7', 'Sem2_21_Gr7', 'Sem3_21_Gr7'];
      //this.chartsems2 = ['2020 Semester 1 | Grade 6', '2020 Semester 2 | Grade 6', '2020 Semester 3 | Grade 6', '2021 Semester 1 | Grade 7', '2021 Semester 2 | Grade 7', '2021 Semester 3 | Grade 7'];
    } else if (grade == "Grade 8") {
      //this.chartsems = ['Sem1_20_Gr7', 'Sem2_20_Gr7', 'Sem3_20_Gr7', 'Sem1_21_Gr8', 'Sem2_21_Gr8', 'Sem3_21_Gr8'];
      //this.chartsems2 = ['2020 Semester 1 | Grade 7', '2020 Semester 2 | Grade 7', '2020 Semester 3 | Grade 7', '2021 Semester 1 | Grade 8', '2021 Semester 2 | Grade 8', '2021 Semester 3 | Grade 8'];
    } else if (grade == "Grade 9") {
      //this.chartsems = ['Sem1_20_Gr8', 'Sem2_20_Gr8', 'Sem3_20_Gr8', 'Sem1_21_Gr9', 'Sem2_21_Gr9', 'Sem3_21_Gr9'];
      //this.chartsems2 = ['2020 Semester 1 | Grade 8', '2020 Semester 2 | Grade 8', '2020 Semester 3 | Grade 8', '2021 Semester 1 | Grade 9', '2021 Semester 2 | Grade 9', '2021 Semester 3 | Grade 9'];
    } else if (grade == "Grade 10") {
      //this.chartsems = ['Sem1_20_Gr9', 'Sem2_20_Gr9', 'Sem3_20_Gr9', 'Sem1_21_Gr10', 'Sem2_21_Gr10', 'Sem3_21_Gr10'];
      //this.chartsems2 = ['2020 Semester 1 | Grade 9', '2020 Semester 2 | Grade 9', '2020 Semester 3 | Grade 9', '2021 Semester 1 | Grade 10', '2021 Semester 2 | Grade 10', '2021 Semester 3 | Grade 10'];
    } else if (grade == "Grade 11") {
      //this.chartsems = ['Sem1_20_Gr10', 'Sem2_20_Gr10', 'Sem3_20_Gr10', 'Sem1_21_Gr11', 'Sem2_21_Gr11', 'Sem3_21_Gr11'];
      //this.chartsems2 = ['2020 Semester 1 | Grade 10', '2020 Semester 2 | Grade 10', '2020 Semester 3 | Grade 10', '2021 Semester 1 | Grade 11', '2021 Semester 2 | Grade 11', '2021 Semester 3 | Grade 11'];
    }

    this.lineChartLabels2 = [];
    this.barChartLabels = [];

    if (subject == "English" && grade == "Grade 7") {
      //Percentage performance score by subject over the 6 semesters
      this.barChartData[0].data = [10, 12, 20, 30, 30, 15];//A
      this.barChartData[1].data = [12, 15, 24, 9, 40, 50];//B
      this.barChartData[2].data = [40, 50, 30, 10, 13, 10];//C
      //this.barChartData[3].data = [27, 20, 13, 40, 50, 5];//Fail
      //this.barChartData[4].data = [30, 33, 24, 30, 15, 30];//Average

      //Average Score: teacher vs. grade teachers over the 6 semesters
      this.lineChartData2[0].data = [62, 64, 59, 57, 62, 65];//Grade Average
      this.lineChartData2[1].data = [55, 61, 52, 35, 55, 62];//Individual teacher average
    } else if (subject == "English" && grade == "Grade 8") {
      //Percentage performance score by subject over the 6 semesters
      this.barChartData[0].data = [30, 22, 20, 10, 35, 25];//A
      this.barChartData[1].data = [42, 40, 44, 40, 40, 60];//B
      this.barChartData[2].data = [10, 20, 30, 10, 3, 10];//C
      //this.barChartData[3].data = [17, 10, 13, 40, 10, 15];//Fail
      //this.barChartData[4].data = [50, 33, 30, 30, 15, 30];//Average

      //Average Score: teacher vs. grade teachers over the 6 semesters
      this.lineChartData2[0].data = [50, 64, 30, 64, 53, 65];//Grade Average
      this.lineChartData2[1].data = [57, 62, 50, 60, 53, 60];//Individual teacher average
    } else if (subject == "English" && grade == "Grade 9") {
      //Percentage performance score by subject over the 6 semesters
      this.barChartData[0].data = [10, 12, 20, 30, 3, 15];//A
      this.barChartData[1].data = [12, 15, 24, 39, 30, 40];//B
      this.barChartData[2].data = [40, 50, 30, 10, 30, 10];//C
      //this.barChartData[3].data = [27, 20, 13, 40, 50, 5];//Fail
      //this.barChartData[4].data = [30, 33, 24, 30, 15, 30];//Average

      //Average Score: teacher vs. grade teachers over the 6 semesters
      this.lineChartData2[0].data = [62, 64, 59, 64, 62, 65];//Grade Average
      this.lineChartData2[1].data = [56, 65, 52, 61, 54, 62];//Individual teacher average
    } else if (subject == "History" && grade == "Grade 8") {
      //Percentage performance score by subject over the 6 semesters
      this.barChartData[0].data = [15, 12, 20, 30, 35, 15];//A
      this.barChartData[1].data = [15, 15, 24, 19, 35, 40];//B
      this.barChartData[2].data = [50, 50, 30, 19, 3, 10];//C
      //this.barChartData[3].data = [27, 20, 13, 40, 50, 5];//Fail
      //this.barChartData[4].data = [30, 33, 24, 30, 15, 30];//Average

      //Average Score: teacher vs. grade teachers over the 6 semesters
      this.lineChartData2[0].data = [50, 60, 50, 55, 55, 65];//Grade Average
      this.lineChartData2[1].data = [57, 61, 52, 60, 55, 60];//Individual teacher average
    } else if (subject == "History" && grade == "Grade 9") {
      //Percentage performance score by subject over the 6 semesters
      this.barChartData[0].data = [30, 32, 30, 30, 30, 15];//A
      this.barChartData[1].data = [12, 15, 24, 29, 3, 30];//B
      this.barChartData[2].data = [10, 50, 30, 10, 30, 30];//C
      //this.barChartData[3].data = [27, 20, 13, 40, 50, 5];//Fail
      //this.barChartData[4].data = [30, 33, 24, 30, 15, 30];//Average

      //Average Score: teacher vs. grade teachers over the 6 semesters
      this.lineChartData2[0].data = [62, 64, 59, 64, 62, 65];//Grade Average
      this.lineChartData2[1].data = [50, 65, 52, 60, 55, 60];//Individual teacher average
    } else if (subject == "History" && grade == "Grade 10") {
      //Percentage performance score by subject over the 6 semesters
      this.barChartData[0].data = [20, 22, 20, 30, 3, 15];//A
      this.barChartData[1].data = [12, 15, 34, 39, 43, 30];//B
      this.barChartData[2].data = [20, 40, 30, 10, 33, 10];//C
      //this.barChartData[3].data = [27, 20, 13, 40, 50, 5];//Fail
      //this.barChartData[4].data = [30, 33, 24, 30, 15, 30];//Average

      //Average Score: teacher vs. grade teachers over the 6 semesters
      this.lineChartData2[0].data = [62, 64, 59, 64, 62, 65];//Grade Average
      this.lineChartData2[1].data = [47, 41, 52, 60, 45, 60];//Individual teacher average
    } else if (subject == "Maths" && grade == "Grade 7") {
      //Percentage performance score by subject over the 6 semesters
      this.barChartData[0].data = [16, 12, 20, 30, 13, 15];//A
      this.barChartData[1].data = [22, 15, 24, 29, 44, 40];//B
      this.barChartData[2].data = [40, 50, 30, 10, 23, 10];//C
      //this.barChartData[3].data = [27, 20, 13, 40, 50, 5];//Fail
      //this.barChartData[4].data = [30, 33, 24, 30, 15, 30];//Average

      //Average Score: teacher vs. grade teachers over the 6 semesters
      this.lineChartData2[0].data = [52, 55, 52, 55, 54, 59];//Grade Average
      this.lineChartData2[1].data = [57, 61, 52, 60, 55, 60];//Individual teacher average
    } else if (subject == "Maths" && grade == "Grade 9") {
      //Percentage performance score by subject over the 6 semesters
      this.barChartData[0].data = [10, 12, 20, 30, 34, 15];//A
      this.barChartData[1].data = [12, 15, 24, 9, 44, 30];//B
      this.barChartData[2].data = [40, 20, 30, 10, 13, 30];//C
      //this.barChartData[3].data = [27, 20, 13, 40, 50, 5];//Fail
      //this.barChartData[4].data = [30, 33, 24, 30, 15, 30];//Average

      //Average Score: teacher vs. grade teachers over the 6 semesters
      this.lineChartData2[0].data = [56, 64, 59, 54, 62, 55];//Grade Average
      this.lineChartData2[1].data = [57, 41, 52, 40, 55, 60];//Individual teacher average
    } else if (subject == "Maths" && grade == "Grade 11") {
      //Percentage performance score by subject over the 6 semesters
      this.barChartData[0].data = [30, 12, 20, 30, 31, 15];//A
      this.barChartData[1].data = [12, 15, 24, 39, 32, 40];//B
      this.barChartData[2].data = [40, 30, 30, 10, 13, 20];//C
      //this.barChartData[3].data = [27, 20, 13, 40, 50, 5];//Fail
      //this.barChartData[4].data = [30, 33, 24, 30, 15, 30];//Average

      //Average Score: teacher vs. grade teachers over the 6 semesters
      this.lineChartData2[0].data = [62, 64, 59, 64, 62, 60];//Grade Average
      this.lineChartData2[1].data = [60, 45, 60, 65, 62, 60];//Individual teacher average
    } else if (subject == "IT" && grade == "Grade 9") {
      //Percentage performance score by subject over the 6 semesters
      this.barChartData[0].data = [15, 12, 20, 30, 15, 15];//A
      this.barChartData[1].data = [12, 15, 24, 39, 20, 40];//B
      this.barChartData[2].data = [40, 50, 30, 10, 45, 10];//C
      //this.barChartData[3].data = [27, 20, 13, 40, 50, 5];//Fail
      //this.barChartData[4].data = [30, 33, 24, 30, 15, 30];//Average

      //Average Score: teacher vs. grade teachers over the 6 semesters
      this.lineChartData2[0].data = [56, 61, 59, 64, 62, 60];//Grade Average
      this.lineChartData2[1].data = [57, 61, 52, 60, 55, 60];//Individual teacher average
    } else if (subject == "IT" && grade == "Grade 10") {
      //Percentage performance score by subject over the 6 semesters
      this.barChartData[0].data = [30, 12, 20, 30, 23, 15];//A
      this.barChartData[1].data = [12, 15, 24, 9, 30, 30];//B
      this.barChartData[2].data = [40, 50, 30, 10, 10, 20];//C
      //this.barChartData[3].data = [27, 20, 13, 40, 50, 5];//Fail
      //this.barChartData[4].data = [30, 33, 24, 30, 15, 30];//Average

      //Average Score: teacher vs. grade teachers over the 6 semesters
      this.lineChartData2[0].data = [53, 64, 53, 59, 54, 59];//Grade Average
      this.lineChartData2[1].data = [57, 61, 52, 40, 55, 60];//Individual teacher average
    } else if (subject == "IT" && grade == "Grade 11") {
      //Percentage performance score by subject over the 6 semesters
      this.barChartData[0].data = [20, 12, 20, 30, 33, 15];//A
      this.barChartData[1].data = [12, 15, 24, 29, 44, 20];//B
      this.barChartData[2].data = [40, 50, 30, 30, 3, 30];//C
      //this.barChartData[3].data = [27, 20, 13, 40, 50, 5];//Fail
      //this.barChartData[4].data = [30, 33, 24, 30, 15, 30];//Average

      //Average Score: teacher vs. grade teachers over the 6 semesters
      this.lineChartData2[0].data = [65, 61, 55, 60, 57, 62];//Grade Average
      this.lineChartData2[1].data = [57, 61, 52, 65, 55, 60];//Individual teacher average
    }

    this.barChartData[3].data = [100 - (this.barChartData[0].data[0] + this.barChartData[1].data[0] + this.barChartData[2].data[0]),
    100 - (this.barChartData[0].data[1] + this.barChartData[1].data[1] + this.barChartData[2].data[1]),
    100 - (this.barChartData[0].data[2] + this.barChartData[1].data[2] + this.barChartData[2].data[2]),
    100 - (this.barChartData[0].data[3] + this.barChartData[1].data[3] + this.barChartData[2].data[3]),
    100 - (this.barChartData[0].data[4] + this.barChartData[1].data[4] + this.barChartData[2].data[4]),
    100 - (this.barChartData[0].data[5] + this.barChartData[1].data[5] + this.barChartData[2].data[5])];

    this.lineChartLabels2 = ['Sem1 2020', 'Sem2 2020', 'Sem3 2020', 'Sem1 2021', 'Sem2 2021', 'Sem3 2021'];
    this.barChartLabels = ['Sem2 21 Gr5', 'Sem2 22 Gr5'];


    console.log("onGradeChange", grade);
  }



  onSubjectOrClassGradeChange(subject, classOrGrade) {
    console.log(subject, classOrGrade);
    this.getSubSubjects(subject.SubjectId);
    this.GetSubjectRankClassStudentCharts(this.studentId, this.selectedSubSubject['SubjectId']);
    /*
    this.lineChartLabels = [];
    this.barChartLabels2 = [];
  this.barChartLabels3 = [];

    if(classOrGrade == "class"){
      switch (subject) {
        case "All Subjects":
          this.lineChartData[0].data = [7, 4, 4, 6, 3, 1];
          this.barChartData2[0].data = [70, 86, 85, 78, 90, 99];

          break;

        case "English":
          this.lineChartData[0].data = [17, 12, 16, 9, 17, 16];
          this.barChartData2[0].data = [55, 90, 70, 88, 90, 97];
          break;

        case "Drama":
          this.lineChartData[0].data = [4, 6, 1, 1, 4, 6];
          this.barChartData2[0].data = [80, 78, 97, 94, 85, 80];
          break;

        case "Religion":
          this.lineChartData[0].data = [4, 2, 8, 8, 4, 2];
          this.barChartData2[0].data = [80, 91, 64, 65, 75, 90];
          break;

        case "Social":
          this.lineChartData[0].data = [8, 8, 4, 3, 4, 8];
          this.barChartData2[0].data = [70, 75, 85, 78, 90, 59];
          break;

        case "Music":
          this.lineChartData[0].data = [3, 9, 6, 3, 4, 1];
          this.barChartData2[0].data = [70, 65, 85, 97, 90, 99];
          break;

        case "Maths":
          this.lineChartData[0].data = [5, 4, 2, 3, 2, 1];
          this.barChartData2[0].data = [70, 86, 85, 95, 90, 75];
          break;

        case "Civics":
          this.lineChartData[0].data = [2, 3, 5, 8, 4, 4];
          this.barChartData2[0].data = [90, 86, 65, 58, 70, 79];
          break;

        default:
          break;
      }
    }else{
      switch (subject) {
        case "All Subjects":
          this.lineChartData[0].data = [77, 47, 42, 6, 3, 1];
          this.barChartData2[0].data = [70, 86, 85, 78, 90, 99];
          break;

        case "English":
          this.lineChartData[0].data = [107, 72, 27, 56, 4, 52];
          this.barChartData2[0].data = [55, 90, 70, 88, 90, 97];
          break;

        case "Drama":
          this.lineChartData[0].data = [46, 67, 1, 1, 43, 86];
          this.barChartData2[0].data = [80, 78, 97, 94, 85, 80];
          break;

        case "Religion":
          this.lineChartData[0].data = [14, 27, 88, 8, 47, 28];
          this.barChartData2[0].data = [80, 91, 64, 65, 75, 90];
          break;

        case "Social":
          this.lineChartData[0].data = [58, 78, 14, 3, 64, 9];
          this.barChartData2[0].data = [70, 75, 85, 78, 90, 59];
          break;

        case "Music":
          this.lineChartData[0].data = [23, 97, 66, 3, 74, 11];
          this.barChartData2[0].data = [70, 65, 85, 97, 90, 99];
          break;

        case "Maths":
          this.lineChartData[0].data = [92, 77, 16, 3, 14, 91];
          this.barChartData2[0].data = [70, 86, 85, 95, 90, 75];
          break;

        case "Civics":
          this.lineChartData[0].data = [29, 33, 75, 60, 94, 41];
          this.barChartData2[0].data = [90, 86, 65, 58, 70, 79];
          break;

        default:
          break;
      }
    }

  this.barChartData3[3].data = this.barChartData2[0].data;

    var average = 0;//var average2 = 0;
    //this.lineChartData[1].data = [];
    this.barChartData2[1].data = [];

    for (let index = 0; index < this.lineChartData[0].data.length; index++) {
      const element = this.lineChartData[0].data[index];
      const element2 = this.barChartData2[0].data[index];
      var rr = Math.floor(Math.random() * (8 - 1 + 1) + 1);
      average += element;
      //average2 += element2;
      this.barChartData2[1].data.push(element2 + rr - 20);
      //console.log("this.barChartData2[1].data.push", element2);
    }

    average = parseFloat((average / this.lineChartData[0].data.length).toFixed(1));
    //average2 = parseFloat((average2 / this.barChartData2[0].data.length).toFixed(2));



    for (let index = 0; index < this.lineChartData[0].data.length; index++) {
      //this.lineChartData[1].data.push(average);
    }

    this.lineChartLabels = ['Sem1 20 Gr7', 'Sem2 20 Gr7', 'Sem3 20 Gr7', 'Sem1 21 Gr8', 'Sem2 21 Gr8', 'Sem3 21 Gr8'];
    this.barChartLabels2 = ['Sem1 20 Gr7', 'Sem2 20 Gr7', 'Sem3 20 Gr7', 'Sem1 21 Gr8', 'Sem2 21 Gr8', 'Sem3 21 Gr8'];
    this.barChartLabels3 = ['Sem1 20 Gr7', 'Sem2 20 Gr7', 'Sem3 20 Gr7', 'Sem1 21 Gr8', 'Sem2 21 Gr8', 'Sem3 21 Gr8']; */
  }

  private getSubSubjectRankByClass() {
    if (this.selectedStudent != null) {
      var childidx = this.selectedStudent.StudentId;
    } else {
      var childidx = this.CurrentChild.ChildId;
    }
    try {
      this.dataAnalyticsService.GetSubSubjectRankByClass(childidx, this.selectedSubject['SubjectId'], this.selectedSubSubject['Id'], this.selectedLevels['Id'], this.selectedTest['TestId']).finally(() => { }).subscribe(
        response => {
          let mappedData: any = response;
          console.log("getSubSubjectRankByClass", mappedData);
          this.lineChartLabels = [];
          this.barChartLabels2 = [];
          this.lineChartData[0].data = mappedData.SubjectRankArrayWithTotalStudents.map(rank => parseInt(rank.split('/')[0]));
          this.barChartData2[0].data = mappedData.OverallSubjectMarksArray;
          //this.barChartData2[1].data = [];
          this.rank_labels = mappedData.SubjectRankArrayWithTotalStudents;
          this.lineChartLabels = mappedData.YearSemesterExamArray;
          this.barChartLabels2 = mappedData.YearSemesterExamArray;
        },
        error => {
          console.log("getSubSubjectRankByClass", error);
          this.loadSubjectRankChartRandomly();
        });
    } catch (error) {
      console.log("getSubSubjectRankByClass Any Param Null");
      //this.loadSubjectRankChartRandomly();
    }

  };

  private loadSubjectRankChartRandomly() {
    this.lineChartLabels = [];
    this.barChartLabels2 = [];
    var data = []; var data2 = [];
    for (let i = 0; i < 2; i++) {
      const classPosition = Math.floor(Math.random() * Number(this.NumberOfStudents)) + 1; // generate a random class position between 1 and NumberOfStudents
      const maxPercentage = 100; // set the maximum percentage
      const minPercentage = 30; // set the minimum percentage
      const percentageScale = (Number(this.NumberOfStudents) - classPosition) / (Number(this.NumberOfStudents) - 1); // calculate the scaling factor based on class position
      const randomPerc = Math.floor((maxPercentage - minPercentage) * percentageScale + minPercentage); // generate a random percentage using the scaling factor

      data.push(classPosition);
      data2.push(randomPerc);
    }
    this.rank_labels = [];
    this.lineChartData[0].data = data;
    this.barChartData2[0].data = data2;
    //this.barChartData2[1].data = [];
    this.barChartLabels2 = ['Sem2 22 Gr5', 'Sem3 22 Gr5'];
    this.lineChartLabels = ['Sem2 22 Gr5', 'Sem3 22 Gr5'];
  }

  private GetStudentsChartOverallPrecentageRank(childid) {
    this.dataAnalyticsService.GetStudentsChartOverallPrecentageRank(childid).finally(() => { }).subscribe(
      response => {
        let mappedData: any = response;
        console.log("GetStudentsChartOverallPrecentageRank", mappedData);
        /*this.lineChartLabels = [];
        this.barChartLabels2 = [];
        this.barChartLabels3 = [];

        this.lineChartData[0].data = [];
        //this.lineChartData[1].data = [];
        this.barChartData2[0].data = [];
        this.barChartData2[1].data = [];
        this.lineChartData[0].data = mappedData.OverallRankArray;
        this.barChartData2[0].data = mappedData.OverallPercentageArray;
        this.barChartData2[1].data = mappedData.ClassOverallPercentageArray;

        this.barChartData3[3].data = this.barChartData2[0].data;
        this.barChartData3[0].data = [];
        this.barChartData3[1].data = [];
        this.barChartData3[2].data = [];
        for (let index = 0; index < this.barChartData3[3].data.length; index++) {
          const element = this.barChartData3[3].data[index];
          this.barChartData3[0].data.push(element - 40);
          this.barChartData3[1].data.push(element - 20);
          if(this.lineChartData[0].data[index] == 1){
            this.barChartData3[2].data.push(element - 5);
          }else{
            this.barChartData3[2].data.push(element + 3);
          }
        }

        var average = 0;
        for (let index = 0; index < this.lineChartData[0].data.length; index++) {
          const element = this.lineChartData[0].data[index];
          average += element;
        }
        average = parseFloat((average / this.lineChartData[0].data.length).toFixed(1));
        for (let index = 0; index < this.lineChartData[0].data.length; index++) {
          //this.lineChartData[1].data.push(average);
        }

        this.rank_labels = mappedData.OverallRankArrayWithTotalStudents;
        this.lineChartLabels = mappedData.YearSemesterExamArray;
        this.barChartLabels2 = mappedData.YearSemesterExamArray;
        this.barChartLabels3 = mappedData.YearSemesterExamArray;
        this.chartsems3 = mappedData.YearSemesterExamArray;*/
      },
      error => {
        console.log("GetStudentsChartOverallPrecentageRank", error);
      });
  };

  private GetSubjectRankClassStudentCharts(childid, subjectid) {
    this.dataAnalyticsService.GetSubjectRankClassStudentCharts(childid, subjectid).finally(() => { }).subscribe(
      response => {
        let mappedData: any = response;
        console.log("GetSubjectRankClassStudentCharts", mappedData);
        this.lineChartLabels = [];
        this.barChartLabels2 = [];
          this.barChartLabels3 = [];

        this.lineChartData[0].data = [];
        //this.lineChartData[1].data = [];
        this.barChartData2[0].data = [];
        //this.barChartData2[1].data = [];
        this.lineChartData[0].data = mappedData.OverallSubjectRankArray;
        this.barChartData2[0].data = mappedData.OverallSubjectMarksArray;
        //this.barChartData2[1].data = mappedData.SubjectClassExamSubjectRankPrecentageArray;
        this.lineChartLabels = mappedData.YearSemesterExamArray;
        this.barChartLabels2 = mappedData.YearSemesterExamArray;

        this.barChartData3[3].data = this.barChartData2[0].data;
        this.barChartData3[0].data = [];
        this.barChartData3[1].data = [];
        this.barChartData3[2].data = [];
          for (let index = 0; index < this.barChartData3[3].data.length; index++) {
            const element = this.barChartData3[3].data[index];
            this.barChartData3[0].data.push(element - 40);
            this.barChartData3[1].data.push(element - 20);
            if(this.lineChartData[0].data[index] == 1){
              this.barChartData3[2].data.push(element - 5);
            }else{
              this.barChartData3[2].data.push(element + 3);
            }
          }

        var average = 0;
        for (let index = 0; index < this.lineChartData[0].data.length; index++) {
          const element = this.lineChartData[0].data[index];
          average += element;
        }
        average = parseFloat((average / this.lineChartData[0].data.length).toFixed(1));
        for (let index = 0; index < this.lineChartData[0].data.length; index++) {
          //this.lineChartData[1].data.push(average);
        }

        this.rank_labels = mappedData.SubjectRankArrayWithTotalStudents.filter(function (el) {return el != null;});

        this.barChartLabels3 = mappedData.YearSemesterExamArray;
        this.chartsems3 = mappedData.YearSemesterExamArray;
      },
      error => {
        console.log("GetSubjectRankClassStudentCharts", error);
      });
  };

  private getSubjects(sid) {
    this.dataAnalyticsService.getSubjects(sid).finally(() => { }).subscribe(
      response => {
        let mappedData: any = response;
        this.subjects = [/*{SubjectName: 'All Subjects', SubjectId: 'all-subjects'}*/];
        this.subjects.push(...mappedData["subsemList"][0]);

        try {
          this.selectedSubject = this.subjects[0];
          this.selectedSubject2 = this.subjects[0];
          this.subject1 = this.subjects[0];
          this.subject2 = this.subjects[1];
          this.changeSubjectCorrelationBetweenSubjects(this.subject1, this.subject2);
          this.getSubSubjects(this.selectedSubject["SubjectId"]);
        } catch (error) {

        }
        //this.onSubjectOrClassGradeChange(this.selectedSubject, this.selectedGCl);
        console.log("getSubjects", mappedData);
      },
      error => {

      });
  };

  getSectionByGrade(grade) {
    this.students = [];
    this.NumberOfStudents = [];
    this.SemesterData = [];
    this.TestData = [];
    this.studentRCData = [];
    this.studentData.standardId = grade.standardId;
    this.selectedSection = null;
    this.nameofstd = grade.standardsName;
    this.sectionList = grade.Sections;

    this.selectedSection = this.selectedGrade.Sections.find(data => {
      return data.sectionName == this.selectedSection.sectionName;
    });
  }

  submit() {
    console.log('log');
    console.log(this.studentId);
    console.log(this.selectedSubSubject);
    this.GetSubjectRankClassStudentCharts(this.studentId, this.selectedSubSubject['SubjectId']);
  }
}



// WEBPACK FOOTER //
// /builds/yaratechnologies/talkative-parents-portal/src/app/parent/dashboard/pages/historical-data/summary.component.ts